/* eslint-disable max-len */

export default {
  errors: {
    global: {
      internal: 'Erro interno',
      not_allowed: 'Ação não permitida',
      access_denied: 'Acesso negado',
      validator_error: 'Erro de validação {details}',
      wrong_body: 'Body errado',
      wrong_token: 'Token errado',
      missing_token: 'Token em falta',
      exclusive_lock: 'Bloqueio exclusivo',
      access_denied_acl: 'Acesso negado (ACL)',
      connection_timeout: 'Conexão expirou',
      login_required: 'Login necessário',
      not_found: 'Não encontrado',
      wrong_value: 'Valor errado',
      token_expired: 'Token expirado',
      service_not_available: 'Serviço não disponível',
      twofa_required: '2FA necessária',
      missing_login_token: 'Login necessário',
    },
    account: {
      banned: 'Conta banida',
      wrong_login_or_password: 'Login ou senha errados',
      wrong_login: 'Login errado',
      wrong_password: 'Senha errada',
      blocked: 'Conta bloqueada',
      missing_email: 'Endereço de email não atribuído',
      same_password_used: 'A mesma senha foi usada',
      apikey_not_created: 'Chave API não foi criada',
      apikey_already_created: 'Chave API já foi criada',
      twofa_not_created: '2FA não foi criada',
      twofa_already_created: '2FA criada',
      deletion_already_started: 'Eliminação da conta já começou',
      wrong_twofa: 'Código 2FA errado',
      external_withdraw_not_available: 'Levantamento exterior não está disponível',
      twofa_limit: 'Limite de 2FA',
      kyc_wrong_step: 'Passo errado de KYC',
      not_exists: 'Não existe',
      kyc_required: 'KYC necessário',
      action_not_allowed: 'Ação não permitida',
      migration: 'Migração',
      wrong_password_pattern: 'A senha deve ter entre 8 a 64 caracteres e pelo menos um caracter: maiúsculo, minúsculo, numérico, especial ',
    },
    market: {
      not_enough_funds: 'Fundos insuficientes',
      missing_steam_token: 'URL de trocas da Steam em falta',
      missing_steam_id: 'Steam ID em falta',
      wrong_item_status: 'Estado do item errado',
      item_already_queued: 'Item já na fila',
      max_price_limit: 'Limite máximo de preço',
      item_not_available: 'Item indisponível',
      steam_vac_ban: 'Banimento VAC na Steam',
      steam_trade_ban: 'Banimento de Trocas na Steam',
      steam_private_profile: 'Perfil da Steam privado',
      steam_private_inventory: 'Inventário da Steam privado',
      steam_tradehold: 'Trocas da Steam congeladas',
      cannot_check_tradeban: 'Não conseguimos verificar um banimento de trocas',
      cannot_check_tradehold: 'Não conseguimos verificar um congelamento de trocas',
      wrong_steam_token: 'Token errado da Steam',
      no_items_found: 'Não foram encontrados itens',
      items_limit: 'Limite de itens',
      instant_sell_disabled: 'Venda instantânea desabilitada ',
      plan_not_found: 'Plano não encontrado',
      price_too_low: 'Preço demasiado baixo',
    },
    steam: {
      wrong_tradelink: 'Link de trocas errado',
      private_inventory: 'Inventário da Steam privado',
      cannot_check_tradeban: 'Não conseguimos verificar o banimento de trocas',
      cannot_check_tradehold: 'Não conseguimos verificar o congelamento de trocas',
      vac_ban: 'Banimento VAC',
      trade_ban: 'Banimento de trocas',
      private_profile: 'Perfil da Steam privado',
      tradehold: 'Congelamento de trocas',
      wrong_token: 'Token errado',
      missing_token: 'URL de trocas da Steam em falta',
      missing_steam_id: 'ID Steam em façta',
      community_ban: 'Banimento Comunitário',
      economy_ban: 'Banimento Económico',
      platform_offline: 'Sem conexão com a Steam, os servidores podem estar em baixo. Por favor tenta de novo mais tarde.',
      cannot_check_escrow: 'Não conseguimos verificar a garantia',
      escrow: 'Estás a usar Steam Guard no email o que não é suficiente para trocares com os nossos bots. Deves ativar o Steam Guard no telemóvel para conseguires fazê-lo.',
      fresh_account: 'Deves configurar o teu perfil da Steam primeiro',
    },
    mutex: {
      long_lock: 'Bloqueio longo, tenta de novo em {ttl} segundos',
      exclusive_lock: 'Bloqueio exclusivo',
    },
    api: {
      missing_apikey: 'Chave API em falta',
      missing_secret: 'Segredo de API em falta',
      wrong_ip_address: 'Endereço de IP errado',
      private_ip_address: 'Endereço de IP privado',
      wrong_apikey: 'Chave API errada',
    },
    record: {
      item_not_found: 'Item não foi encontrado',
      item_not_owned: 'Item não é seu',
      own_item: 'Próprio item',
      there_are_no_records: 'Não há registros para mostrar',
      record_already_exists: 'Registro já existe',
      record_not_exists: 'Registro não existe',
      already_exists: 'Já existe',
      not_exists: 'Não existe',
      not_updated: 'Não carregado',
      forbidden: 'Proibído',
    },
    bot: {
      not_found: 'Bot não encontrado',
      not_available: 'Bot indisponível',
    },
    wallet: {
      cannot_transfer_money: 'Dinheiro não pode ser transferido',
      amount_negative: 'Quantia negativa',
      amount_positive: 'Quantia positiva',
      card_scoring_too_low: 'Pontuação de cartão demasiado baixa',
      not_enough_balance: 'Saldo insuficiente',
      kyc_window_limit: 'Limite de janelas KYC',
      service_window_limit: 'Limite de janelas de serviço',
      amount_limit: 'Limite de quantia',
      wrong_wallet_address: 'Endereço de carteira errado',
      card_not_found: 'Cartão não econtrado',
      cannot_process_transaction: 'Não conseguimos processar a tua transação',
      only_past_months_accepted: 'Apenas os últimos meses são aceites',
      only_visa_allowed: 'Apenas cartões VISA são permitidos',
      you_cannot_complete_this_action: 'Não podes completar a ação porque não tens fundos suficientes na tua conta.',
      you_need_to_deposit_at_least_x: 'Precisas de depositar pelo menos {x} para completar esta ação.',
    },
    gift_code: {
      not_found: 'Código não encontrado',
      already_used: 'Código já está a ser usado',
      own_code: 'Este é o teu próprio código',
    },
    partner: {
      subaccount_not_enabled: 'Conta secundária não habilitada',
      link_account_first: 'Vincula a conta primeiro',
      account_already_linked: 'Conta já vinculada',
      wrong_phrase: 'Frase errada',
      cannot_link_yourself: 'Não te podes vincular a ti próprio',
      account_already_exists: 'Conta já existe',
    },
    payment: {
      card_scoring: 'Pontuação de cartão é demasiado baixa',
      payment_issue: 'Problema com o pagamento',
    },
    auth: {
      failed_to_authenticate: 'Falhou em autenticar-se',
      not_valid_identity: 'Identidade inválida',
      authentication_failed: 'Autenticação falhada',
    },
    social: {
      cannot_create_chat: 'Conversa não pode ser criada',
    },
    support: {
      wrong_status: 'Estado errado',
      ticket_limit: 'Limite de tickets',
    },
    ipn: {
      verification_issue: 'Problema de verificação',
    },
    affiliate: {
      same_code: 'Mesmo código',
      code_taken: 'O código já foi utilizado',
      not_activated: 'Não ativado',
      not_enough_balance: 'Saldo insuficiente',
    },
    bam: {
      bam_steam_015: 'Os nossos bots perderam as sessões Steam. Por favor tenta de novo em alguns minutos.',
    },
  },
  validator: {
    required: 'Este campo é necessário.',
    string: 'Este campo deve ser uma linha.',
    stringEmpty: 'Este campo não pode estar vazio',
    stringMin: 'Este campo deve ter pelo menos {expected} caracteres.',
    stringMax: 'Este campo deve ter no máximo {expected} caracteres.',
    stringLength: 'Este campo deve ter {expected} caracteres.',
    stringPattern: 'Este campo falhou em ter o padrão necessário.',
    stringPatternLatin: 'Por favor usa caracteres latinos apenas.',
    stringContains: 'Este campo deve conter o texto "{expected}\'.',
    stringEnum: 'Este campo não corresponde a nenhum dos valores permitidos.',
    stringNumeric: 'Este campo deve ser uma linha numérica.',
    stringAlpha: 'Este campo deve ser uma linha alfabética.',
    stringAlphanum: 'Este campo deve ser uma linha alfanumérica.',
    stringAlphadash: 'Este campo deve ser uma linha alphadash.',
    stringHex: 'Este campo deve ser uma linha hexadecimal.',
    stringSingleLine: 'Este campo deve ser uma linha singualr.',
    stringBase64: 'Este campo deve ser uma linha de base64.',
    number: 'Este campo deve ser um número.',
    numberMin: 'Este campo deve ser maior ou igual a {expected}.',
    numberMax: 'Este campo deve ser menor ou igual a {expected}.',
    numberEqual: 'Este campo deve ser igual a {expected}.',
    numberNotEqual: 'Este campo não pode ser igual a {expected}.',
    numberInteger: 'Este campo deve ser um número inteiro.',
    numberPositive: 'Este campo deve ser um número positivo.',
    numberNegative: 'Este campo deve ser um número negativo.',
    array: 'Este campo deve ser uma variante.',
    arrayEmpty: 'Este campo não deve ser uma variante vazia.',
    arrayMin: 'Este campo deve conter pelo menos {expected} itens.',
    arrayMax: 'Este campo deve conter tantos ou menos que {expected} itens.',
    arrayLength: 'Este campo deve conter {expected} itens.',
    arrayContains: 'Este campo deve conter o item \'{expected}\'.',
    arrayUnique: 'O valor \'{actual}\' não é único dos valores \'{expected}\'.',
    arrayEnum: 'O valor \'{actual}\' não corresponde a nenhum dos valores \'{expected}\'.',
    tuple: 'Este campo deve ser uma variante.',
    tupleEmpty: 'Este campo não deve ser uma variante vazia.',
    tupleLength: 'Este campo deve conter {expected} itens.',
    boolean: 'Este campo deve ser uma variante binária.',
    currency: 'Este campo deve ser um formato de moeda',
    date: 'Este campo deve ser uma Data.',
    dateMin: 'Este campo deve ser maior ou igual a {expected}.',
    dateMax: 'Este campo deve ser menor ou igual a {expected}.',
    enumValue: 'O valor \'{expected}\' deste campo não corresponde a nenhum dos valores permitidos.',
    equalValue: 'O valor deste campo deve ser igual a \'{expected}\'',
    equalField: 'O valor deste campo deve ser igual ao valor do campo \'{expected}\'.',
    forbidden: 'Este campo é proibido.',
    function: 'Este campo deve ser uma função.',
    email: 'Este campo deve ser um email válido.',
    emailEmpty: 'Este campo não deve estar vazio.',
    emailMin: 'Este campo deve ter pelo menos {expected} caracteres.',
    emailMax: 'Este campo deve ter no máximo {expected} caracteres.',
    luhn: 'Este campo deve ser uma soma de verificação luhn válida.',
    mac: 'Este campo deve ser um endereço MAC válido.',
    object: 'Este campo deve ser um Objeto.',
    objectStrict: 'Este objeto contém chaves proibidas:  \'{actual}\'.',
    objectMinProps: 'Este objeto deve conter pelo menos {expected} propriedades.',
    objectMaxProps: 'Este objeto deve conter no máximo {expected} propriedades.',
    url: 'Este campo deve ser um URL válido.',
    urlEmpty: 'Este campo não deve estar vazio.',
    uuid: 'Este campo não é um formato de código válido.',
    uuidVersion: 'Este campo deve ser uma versão UUID fornecida válida.',
    classInstanceOf: 'Este campo deve ser uma instância da classe \'{expected}\'.',
    objectID: 'Este campo deve ser um ObjectID válido.',
    record: 'Este campo deve ser um Objeto.',
  },
  body: {
    language: 'Linguagem',
    currency: 'Moeda',
    currency_warning: 'Todas as operações são feitas em dólares americanos, outras moedas são convertidas para o dólar americano e apenas mudam a forma como a página é visível. Mudanças nas taxas de câmbio podem aumentar ou diminuir o teu saldo.',
    choose_game: 'Escolher o jogo',
    slider: {
      title_1: 'Atualiza o teu estilo,',
      title_2: 'domina o jogo',
      content_1: 'Descobre a melhor coleção de skins',
      content_2: 'Para elevar a tua experiência no jogo.',
      tile_1: 'Maximiza a tua experiência no jogo',
      tile_2: 'Obtém o melhor valor pelo teu dinheiro',
      tile_3: 'Aproveita trocas seguras e perfeitas',
    },
    footer_description: 'Na BitSkins, nós temo-nos dedicado a fornecer uma plataforma segura e protegida para os jogadores comprarem e venderem itens de jogos populares como CS2, Dota 2, Rust e TF2. Desde o nosso lançamento em 2015, nós servimos com sucesso milhões de clientes satisfeitos, e o nosso compromisso na segurança e proteção mantém-se mais forte que nunca.',
    footer_disclaimer: '© 2015 - {year} BitSkins. Powered by Steam. Not affiliated with Valve Corp.',
    footer_email_support: 'Se precisas de ajuda',
    footer_email_security: 'Se queres denunciar bugs',
    footer_email_partnership: 'Se queres cooperar',
    market: 'Mercado',
    cart: 'Carrinho de compras',
    cart_empty: 'O teu carrinho está vazio',
    clear_cart: 'Esvaziar o carrinho',
    checkout: 'Pagamento',
    in_the_cart: 'no carrinho',
    total: 'Total',
    go_to_market: 'Ir para o mercado',
    trustpilot_alt: 'Trustpilot com {stars} estrelas e {reviews} reviews',
    reload_website: 'Recarrega o website!',
    app_error: 'Erro de aplicação: {error}',
    latest_articles: 'Últimos artigos',
    steam_login: 'Login pela Steam',
  },
  maintenance: {
    we_will_be_back_soon: 'Voltámos em breve',
    we_are_down_for_maintenance: 'Estamos em baixo para manutenção mas voltaremos em breve.',
    sorry_for_the_inconvenience: 'Desculpa pela inconveniência e até já!',
  },
  account: {
    email: {
      required: 'Endereço de email necessário',
      required_for_this_payment_method: 'Não podes usar este método de pagamento porque não introduziste ainda o teu endereço de email.',
      you_can_start_now: 'Podes começar o processo de configuração agora.',
      setup: 'Configurar email',
    },
    add_funds: 'Adicionar fundos',
    my_store: 'A minha loja',
    selling: 'À venda',
    transactions: 'Transações',
    settings: 'Definições',
    steam_settings: {
      open_settings: 'Abrir definições',
      open_steam_settings: 'Abrir o perfil da Steam',
      what_is_steam_guard: 'O que é o Steam Guard?',
      inventory_status: 'Estado de inventário',
      profile_status: 'Estado de perfil',
      change_trade_link: 'Mudar o link de trocas',
    },
    logout: 'Sair',
    inventory: 'Inventário',
    banned: {
      you_are_banned: 'Estás <span class="text-cr">banido</span>',
      your_account_has_been_banned: 'A tua conta foi banida por violar o nosso',
      your_account_has_been_blocked: 'A tua conta foi bloqueada por violar o nosso',
      if_you_believe: 'Se acreditas que foi um erro podes contactar-nos em <span class="text-cp">support{\'@\'}bitskins.com</span>',
      terms_of_use: 'Termos de Uso',
    },
    account_blocked: 'Conta <span class="text-cr">bloqueada</span>',
    api_access: 'Acesso API',
  },
  balance: {
    wallet: 'Carteira',
    withdraw: 'Levantamento',
    withdraw_to: 'Levantar para',
    withdraw_again: 'Levantar de novo',
    withdrawable: 'Disponível para levantamento',
    total: 'Total',
    balance: 'Saldo',
    deposits_and_sales: 'Depósitos e vendas',
    proceeds_from_sales: 'Procedente das vendas',
    deposit: 'Depósito',
    locked: 'Bloqueado',
    funds_locked: 'Fundos bloqueados em transações',
    pending_withdrawals: 'Levantamentos em espera',
    thank_you_for_your_payment: 'Obrigado pelo teu pagamento',
    your_money_will_arrive_soon: 'O teu dinheiro chegará em breve',
    your_payment_is_still_processing: 'O teu pagamento ainda está a ser processado, mas os fundos deverão aparecer na tua conta em breve.',
    in_case_you_do_not_receive: 'No caso de não receberes os fundos dentro de 15 minutos, por favor contacta o nosso suporte.',
    payment_pending: 'Pagamento <span class="text-cbs">em espera</span>',
    payment_failed: 'Pagamento<span class="text-cr">falhado</span>',
    payment_canceled: 'Pagamento <span class="text-cg">cancelado</span>',
    payment_has_been_cancelled: 'O pagamento foi cancelado como pedido',
    unfortunately_we_were_unable: 'Infelizmente não fomos capazes de processar o teu pagamento',
    please_try_again: 'Por favor tenta de novo',
    if_the_problem_persists: 'Se o problema persistir, por favor contacta o nosso suporte. Também podes tentar usar um método de pagamento diferente. ',
    back_to_wallet: 'De volta à carteira',
    total_description: 'Os fundos que vêm dos teus depósitos e vendas',
    withdrawable_description: 'Os procedentes das vendas. Estes fundos podem ser levantados ou gastos na compra de itens.',
    locked_description: 'Fundos temporariamente bloqueados que não podem ser gastos ou levantados. A razão pela qual os fundos estão a ser bloqueado é devido à existência de ordens de compra, compra de itens, etc...',
    deposit_with_cryptocurrencies: 'Depositar com <span class="text-cp">criptomoedas:</span>',
    deposit_with_standard_payment_methods: 'Depositar com <span class="text-cp">métodos de pagamento normais:</span>',
    withdraw_with_cryptocurrencies: 'Levantar através de <span class="text-cp">criptomoedas:</span>',
    withdraw_with_standard_payment_methods: 'Levantar através de <span class="text-cp">métodos de pagamento normais:</span>',
    your_amount: 'A tua quantia',
    your_limit: 'O teu limite',
    your_limits: 'Os teus limites',
    increase_your_limits: 'Aumenta os teus limites',
    payment_not_available_in_the_following_countries: 'Este método de pagamento não se encontra disponível nos seguintes países:',
    the_price_is_updated_every_60_seconds: 'O preço é atualizado a cada 60 segundos e é o preço médio obtido de várias trocas.',
    rate_includes_x_fee: 'A tarifa inclui uma taxa de {x}%.',
  },
  not_found: {
    title: 'Página não encontrada',
    message: 'Parece que estás perdido. Podes encontrar as tuas<br> skins de sonho na página do mercado.',
  },
  login: {
    welcome_to_bitskins: '<span class="text-cp">Bem vindo</span> à BitSkins',
    sign_in: 'Entrar',
    sign_up: 'Registrar',
    rules_text: 'Eu confirmo que tenho 18 anos ou mais e concordo com os',
    sign_in_with_steam: 'Entrar com a Steam',
    sign_up_with_steam: 'Registrar com a Steam',
    email: 'Email',
    password: 'Senha',
    already_have_an_account: 'Já tens uma conta? Clica',
    to_login: 'para entrar',
    to_login_via_email: 'para entrar através do email',
    login_via_email: 'Entrar através do email',
    log_in_using_your_email: 'Entrar através de endereço de email e senha.',
    forgot_password: 'Esqueceste-te da tua senha?',
    login_via_steam: 'ENTRAR COM A STEAM',
    register_first: 'Primeiro precisas de te registrar',
    passwords_not_migrated: 'Infelizmente devido a recentes atualizações não conseguimos migrar a tua senha, sendo assim precisarás de a alterar.',
  },
  common: {
    monthly: 'mensalmente',
    x_to_y: '{x} para {y}',
    minimum_x: '{x} mínimo',
    maximum_x: '{x} máximo',
    click: 'Clicar',
    claim: 'Reivindicar',
    or: 'ou',
    and: 'e',
    confirm: 'Confirmar',
    continue: 'Continuar',
    cancel: 'Cancelar',
    enable: 'Habilitar',
    enabled: 'habilitado',
    disable: 'Desabilitar',
    disabled: 'desabilitado',
    download: 'descarregar',
    twofa: 'Autenticação de 2-Fatores',
    terms_of_use: 'Termos de Uso',
    privacy_policy: 'Política de Privacidade',
    cookie_policy: 'Política de Cookies',
    about_us: 'Sobre nós',
    changelog: 'Changelog',
    faq: 'FAQ',
    support: 'Suporte',
    affiliate: 'Afiliados',
    blog: 'Blog',
    careers: 'Carreiras',
    api: 'API',
    service_status: 'Estado de serviço',
    loading: 'A carregar...',
    buy_skins: 'Comprar skins',
    sell_skins: 'Vender skins',
    popular: 'Popular',
    skin_categories: 'Categorias de skins',
    payments: 'Pagamentos',
    about_bitskins: 'Sobre a BitSkins',
    social_media: 'Redes sociais',
    follow_us: 'Segue-nos e junta-te à nossa comunidade!',
    enter_your_email: 'Digita o teu endereço de email',
    phone_number: 'Número de telemóvel',
    verify: 'Verificar',
    add: 'Adicionar',
    update: 'Atualizar',
    check_spam_folder: 'Se não consegues encontrar o email na tua caixa de entrada por favor verifica a caixa de spam.',
    here: 'aqui',
    edit: 'editar',
    save: 'salvar',
    copy: 'copiar',
    back: 'Voltar',
    back_to_login: 'Voltar para o login',
    clear: 'Limpar',
    quantity: 'Quantidade',
    name: 'Nome',
    bot_name: 'Nome do bot',
    steam: 'Steam',
    steam_id: 'ID Steam',
    steam_group: 'Grupo da Steam',
    browser: 'Navegador',
    on: 'On',
    off: 'Off',
    hidden: 'Escondido',
    empty: 'Vazio',
    expires_in: 'Expira em',
    member_since: 'Membro desde',
    close: 'Fechar',
    paint_seed_value: 'Paint seed: {value}',
    error: 'Erro',
    retry: 'Tenta novamente',
    no_options_available: 'Sem opções disponíveis',
    search: 'Procurar',
    any: 'Qualquer',
    min: 'Min.',
    max: 'Máx.',
    no_limit: 'Sem limite',
    scroll_left: 'desliza para a esquerda',
    scroll_right: 'desliza para a direita',
    load: 'Carregar',
    delete: 'Eliminar',
    remove: 'Remover',
    all: 'Tudo',
    game: 'Jogo',
    reset: 'Resetar',
    in: 'em',
    optional: '(opcional)',
    default: 'Padrão',
    filter: 'Filtro',
    up_to: 'Até',
    similar: 'Semelhante',
    important: 'Importante',
    step: 'Passo',
    share_link: 'Link de partilha',
    zoom: 'Zoom',
    found: 'Encontrado',
    try_again: 'Tenta de novo',
    of: 'de',
    timer: 'Temporizador',
    add_new: 'Adicionar novo',
    and_more: 'E MAIS',
    check_status: 'Verificar o estado',
    resend_link: 'Reenviar link',
    back_to_home: 'Voltar à página principal',
    data_visible_only_to_logged_in_users: 'Esta informação é visível apenas para utilizadores',
    login: 'Entrar',
    level: 'Nível',
    twofa_code: 'Código 2FA',
    id: 'ID',
    position: 'Posição',
    amount: 'Quantia',
    progressive_sum: 'Soma progressiva',
    date: 'Data',
    active: 'Ativo',
    yes: 'Sim',
    no: 'Não',
  },
  notifications: {
    change: 'Mudar',
    setup: 'Configurar',
    disconnect: 'Desconectar',
    connect: 'Conectar',
    notifications: 'Notificações',
    notifications_center: 'Centro de notificações',
    clear_all: 'Limpar todas as notificações',
    notifications_channels: 'Canais de notificações',
    connected: 'Conectado',
    all_notifications: 'Todas as notificações',
    sound: 'Som',
    volume_mute: 'Sem som',
    volume_full: 'Volume máximo',
    all_sounds: 'Todos os sons:',
    off: 'Off',
    on: 'On',
    steam_issues_title: 'Problemas com a Steam',
    steam_issues_content: 'A Steam está a experienciar problemas que podem impactar trocas, fazendo com que não sejam processadas ou criadas.',
    name: {
      account_new_login: 'Novo login na conta',
      inventory_sold: 'Inventário vendido',
      inventory_buyorder: 'Ordem de compra de inventário',
      wallet_deposit_done: 'Depósito na carteira feito',
      support_new_reply: 'Nova resposta do Suporte',
      support_ticket_closed: 'Ticket de Suporte fechado',
      inventory_bargain_received: 'Barganha de inventário recebida',
    },
  },
  market: {
    non_scraped_only: 'Não-raspado apenas',
    set_price: 'Definir preço',
    game_not_found: 'Jogo não encontrado',
    game_not_available: 'Jogo indisponível neste momento',
    any_stickers: 'Qualquer um',
    item_removed_from_sale: 'Item removido da venda',
    price_updated: 'Preço atualizado',
    item_withdrawn: 'Este item foi levantado',
    go_to_withdrawn: 'Ir para levantar itens',
    item_issue: 'Nós temos um problema com este item',
    item_in_deposit_queue: 'Este item está na fila de depósitos',
    item_in_withdraw_queue: 'Este item está na fila de levantamentos',
    go_to_queued: 'Ir para itens em fila',
    item_in_bitskins_inventory: 'Este item está no teu inventário BitSkins',
    go_to_inventory: 'Ir para inventário',
    go_to_issue: 'Ir para problemas',
    maximum_price: 'Preço máximo',
    minimum_price: 'Preço mínimo',
    average_price: 'Preço Médio',
    amount_sold: 'Quantidade vendida',
    withdrawal_batch_info: 'Por favor, tem em atenção de que estamos a enviar itens em lotes espaçadamente.',
    queued: 'Em fila',
    queued_description: 'Aqui podes encontrar itens que estão em fila para levantamento ou depósito.',
    withdrawn: 'Levantado',
    withdrawn_description: 'Aqui podes encontrar itens que foram levantados',
    issues: 'Problemas',
    issues_description: 'Aqui podes encontrar itens com os quais estamos a ter problemas. Estamos a trabalhar para resolver estes problemas.',
    max_items_selected: 'Não podes selecionar mais que {limit} itens',
    item_status: 'Estado do item',
    search_for_stickers: 'Procurar por autocolantes',
    this_item: '(este item)',
    no_items_found: {
      no_items_found: 'Não foram encontrados itens',
      no_items_found_span: 'Não foram encontrados <span>itens</span>',
      we_could_not_find_any_offers: 'Não conseguimos encontrar nenhumas ofertas',
      for: 'para',
      this_can_be_due_to_applied_filters: 'Isto pode ser devido aos filtros aplicados. Podes limpar todos os filtros clicando no botão abaixo',
    },
    only_tradable_items: 'Apenas itens trocáveis',
    not_accepting: 'Não aceitando',
    sell: 'Vender',
    skin: 'Skin',
    items: 'itens',
    items_v2: 'itens',
    buy_orders: 'Ordens de compra',
    search_for: 'Pesquisar por itens de {game}',
    search_for_items: 'Procurar por itens',
    reload: 'Recarregar',
    item_name: 'Nome do item',
    enter_item_name: 'Digita o nome do item',
    price: 'Preço',
    reset: 'Resetar',
    all_items: 'Todos os itens',
    sort: 'classificação',
    add_sort: 'Adicionar classificação',
    steam_price: 'Preço Steam',
    reference_price: 'Preço de referência',
    steam_inventory: 'Inventário Steam',
    your_steam_inventory: 'O teu inventário Steam',
    bitskins_inventory: 'Inventário BitSkins',
    your_bs_inventory: 'O teu inventário BitSkins {extra}',
    refresh: 'Atualizar',
    learn_how_to_sell: 'Aprende a vender',
    select_1_by_1: 'Selecionar 1 por 1',
    select_all: 'Selecionar todos',
    selected_items: 'Selecionar itens',
    items_amount: '{count} itens',
    offers: 'ofertas',
    favorites: 'Favoritos',
    last: 'Último',
    viewed: 'vistos',
    same_price: {
      same_price_for: 'O mesmo preço para',
      all_items: 'todos os itens',
    },
    save_all: 'Salvar todos',
    trade_hold: {
      name: 'Congelamento de trocas',
      between: 'Bloqueado entre {min} e {max} dias',
      less: 'Bloqueado por menos de {value} dias',
      any: 'Qualquer congelamento de trocas',
      none: 'Sem congelamento',
      withdrawable_in_days_hours: 'Pode ser levantado em {days} dias, {hours} horas',
      withdrawable_in_hours_minutes: 'Pode ser levantado em {hours} horas, {minutes} minutos',
      tradable: 'Trocável',
    },
    filter: {
      status: 'Estado',
      date_from: 'Data desde',
      date_to: 'Data até',
      amount_from: 'Quantia de',
      amount_to: 'Quantia até',
      price_from: 'Preço de',
      price_to: 'Preço até',
      service: 'Serviço',
      item: 'Item',
      game: 'Jogo',
      type: 'Tipo',
      quality: 'Qualidade',
      exterior: 'Exterior',
      category: 'Categoria',
      collection: 'Coleção',
      color: 'Cor',
      family: 'Família de skins',
      phase: 'Fase',
      rarity: 'Raridade',
      grade: 'Grau',
      killstreak: 'Recorde de Kills',
      effect: 'Efeito',
      hero: 'Herói',
      nametag: 'Crachá',
      hightier: 'Tier alto',
      stickers: 'Autocolantes',
      slot: 'Abertura {value}',
      paint_seed: 'Seed de Pintura',
      paint_index: 'Index de Pintura',
      sticker_counter: 'Quantidade de stickers',
      float_value: 'Float',
      active: '{value} ativo',
      by_slot_position: 'Por posição de abertura',
      filter_name: 'Filtros de nome',
      you_can_have: 'Tu podes ter',
      filters_saved: 'filtros salvos',
      choose_stickers: 'Escolher autocolantes',
      no_stickers_found: 'Não foram encontrados autocolantes',
      basic_filters: 'Filtros básicos',
      advanced_filters: 'Filtros avançados',
      clear_all_filters: 'Limpar todos os filtros',
      save_filters: 'Salvar filtros',
      my_filters: 'Os meus filtros',
      filters_are_not_available_on_this_page: 'Filtros não estão disponíveis nesta página',
    },
    loading_item: 'A carregar item',
    bestseller: 'Melhor vendedor',
    this_is_your_item: 'Este é o teu item',
    action: {
      screenshot: 'Captura de ecrã',
      inspect: 'Inspecionar no jogo',
      view_at_steam: 'Ver na Steam',
      check_on_steam_market: 'Verificar no mercado Steam',
      share: 'Partilhar',
      sell_instantly: 'Vender instantaneamente',
      buy: 'Comprar',
      remove_from_sale: 'Remover da venda',
      check_on_market: 'Verificar no mercado',
      item_page: 'Página de itens',
      bulk_buy: 'Comprar em conjunto',
      add_to_favorites: 'Adicionar aos favoritos',
      remove_from_favorites: 'Remover dos favoritos',
      buy_now: 'Comprar agora',
      bump: 'Ressalto',
      sticker: 'Itens com este autocolante',
    },
    bump_minimum: 'Ressalto está apenas disponível para itens mais caros que {amount}',
    your_price: 'O teu preço',
    cart: {
      add_to_cart: 'Adicionar ao carrinho',
      remove_from_cart: 'Remover do carrinho',
      add_stickers_to_cart: 'Adicionar itens ao carrinho',
      remove: 'Remover',
      in_cart: 'No carrinho',
    },
    details: 'Detalhes',
    tags: 'Tags',
    do_you_want_rename: 'Queres renomear os teus itens',
    currently_not_available: 'Indisponível de momento',
    nametag: 'Crachá',
    sales: 'Vendas',
    private_offer: 'Oferta privada',
    private_offers: 'Ofertas privadas',
    private_offers_description: 'Tens {counter} ofertas privadas. Podes encontrá-las',
    public_offer: 'Oferta pública',
    offer_visible_only_to_people_with_link: 'Esta oferta é apenas visível para pessoas que têm um link para a mesma',
    checkout: {
      if_any: 'Se algum dos itens no teu carrinho não estiver mais disponível não serão adicionados para a tua compra',
      remove_all_items: 'Remover todos os itens',
      order_summary: 'Pedir sumário',
      you_will_save: 'Irás salvar',
      i_have_read: 'Li e concordo com os Termos de Serviço e Política de Privacidade e percebo que todas as compras são finais e não reembolsáveis.',
      confirm_checkout: 'Confirmar compra',
      you_need_to_deposit_at_least_x: 'Precisas de depositar pelo menos {amount} para comprar os itens no teu carrinho.',
      you_cannot_complete: 'Não podes completar esta compra porque não tens fundos suficiente na tua conta. Precisas de depositar pelo menos {amount} para comprar os itens do teu carrinho.',
      these_items_will_be_removed: 'Estes itens serão removidos da lista depois de serem comprados.',
      this_item_will_not_be_included: 'Este item não será incluído na tua compra.',
      need_tos_accept: 'Tens de concordar com os Termos de Serviço e Política de Privacidade',
      no_items_selected: 'Sem itens selecionados',
    },
    deposit_status: {
      available: 'Disponível',
      missing: 'Em falta',
      not_accepting: 'Não aceitamos',
      wrong_price: 'Preço errado',
      already_queue: 'Já na fila',
      locked: 'Bloqueado',
    },
    withdraw_progress: {
      status: 'Estado de Levantamento',
      selected: 'Selecionado',
      waiting: 'À espera',
      in_queue: 'Na fila',
      trade_link: 'Link de trocas',
      done: 'Feito',
      error: 'Erro',
      failed: 'Falhou',
      pending: 'Em espera',
    },
    trade_state: {
      Invalid: 'Inválido',
      Active: 'Ativo',
      Accepted: 'Aceite',
      Countered: 'Contrariado',
      Expired: 'Expirado',
      Canceled: 'Cancelado',
      Declined: 'Declinado',
      InvalidItems: 'Itens inválidos',
      CreatedNeedsConfirmation: 'Criado, precisa de confirmação',
      CanceledBySecondFactor: 'Cancelado por segundo fator',
      InEscrow: 'Em garantia',
    },
    trade_type: {
      deposit: 'Depositar',
      withdraw: 'Levantar',
      bidirectional: 'Bi-direcional',
    },
    inventory: {
      history: 'Histórico',
      active_trades: 'Trocas ativas',
      loading_your_inventory: 'A carregar o teu inventário',
      lower_sale_fee: 'taxa de venda {value}% menor',
      group_diff_price: 'Nem todos os itens no grupo têm o mesmo preço',
      group_diff_delist: 'Nem todos os itens no grupo estão marcados para exclusão',
      delist: 'Excluir',
      this_may_take_a_while: 'Isto pode demorar um bocado',
      relist_items: 'Realistar itens',
      cancel_relisting: 'Cancelar realistamento ',
      cancel_withdrawal: 'Cancelar levantamento',
      withdraw_items: 'Levantar itens',
      cancel_editing: 'Cancelar edição',
      edit_items: 'Editar itens',
      sell_items: 'Vender itens',
      steam_offers: 'Ofertas Steam',
      clear_withdraw_items: 'Limpar itens',
      loading_inventory: 'A carregar o inventário',
      update_x_items: 'Atualizar {amount} itens',
      delist_x_items: 'Excluir {amount} itens',
    },
    message: {
      failed_to_create_trade_offer: 'Falhou ao criar proposta de troca',
      offer: 'Oferta {hash}',
      offer_failed: 'Oferta falou (com estado {state})',
      offer_confirmed: 'A tua oferta foi confirmada e listaste com sucesso os teus itens para venda',
      offer_sent: 'A tua proposta de troca foi enviada',
      open_trade: 'Abrir proposta de troca',
      withdraw: 'Levantar oferta {hash}',
      withdraw_confirmed: 'O teu levantamento foi aceite',
      offer_preparing: 'A tua troca está a ser processada. Vamos enviar-te a proposta em breve',
      offer_active: 'A tua troca está pronta. Aceita aqui',
      offer_needs_confirmation: 'Confirmar troca na aplicação móvel',
    },
    deposit_type: {
      public: 'Público',
      public_description: 'O teu item estará visível para todos os utilizadores BitSkins. Esta é a opção de venda mais popular.',
      private: 'Privado',
      private_description: 'Os teus itens estarão apenas visíveis para pessoas que têm o link para os mesmos. Venda privada é 50% mais barata que uma venda normal.',
      instant_sell: 'Venda instantanea',
      instant_description: 'Depois de enviar os itens para o nosso bot, o dinheiro será creditado na tua conta imediatamente.',
    },
    click_to_open: 'Clica para abrir o link numa nova tabela.',
    no_active_trades: 'Sem trocas ativas',
    go_to_all_trades: 'Ir para todas as trocas',
    update_trade_link: 'Atualizar link de troca',
    withdraw: 'Levantar',
    lowest_price: 'Menor preço:',
    no_filters_available: 'Sem filtros disponíveis',
    select_a_hero: 'Seleciona um herói:',
    view_all_items: 'Ver todos os itens',
    stattrak: 'StatTrak™',
    item_not_available: 'Este item não está mais disponível',
    out_of_stock: 'Sem stock',
    find_similar_item: 'Encontra um item semelhante',
    find_similar_items: 'Encontra itens semelhantes',
    sell_for: 'Vender por',
    recommended: 'Recomendado',
    price_discounted: 'Preço com desconto',
    price_average: 'Preço médio (recomendado)',
    price_expensive: 'Preço alto',
    sticker: 'autocolante',
    more: 'Mais',
    recent: 'Recente',
    item_not_found: 'Item não encontrado',
    for: 'para',
    you_will_pay: 'Irás pagar',
    fade: 'Fade: {value}%',
    see_all_items: 'Ver todos os {amount} itens',
    it_my_take_a_while: 'Isto pode demorar um pouco',
    no_transactions_found: 'Sem transações encontradas',
    item: 'Item',
    edit: 'Editar',
    add_items_to_edit: 'Adicionar itens para edição',
    add_items_to_delist: 'Adicionar itens para exclusão',
    add_items_to_sale: 'Adicionar itens para venda',
    add_items_to_withdraw: 'Adicionar itens para Levantamento',
    group_by_name: 'Agrupar por nome',
    select_items_from_your_inventory: 'Selecionar itens do teu inventário',
    earnings: 'Ganhos',
    total_fee: 'Taxa total',
    total_amount: 'Quantia total',
    confirm_purchase: 'Confirmar <span class="text-cp">compra</span>',
    thank_you_for_shopping_with_us: '<span class="text-cp">Obrigado</span>por comprar connosco!',
    you_have_purchased_x_items_for: 'Compraste <span class="text-cp">{x}</span> itens por',
    you_have_purchased_x_for: 'Compraste <span class="text-cp">{x}</span> por',
    total: 'Total',
    you_saved: 'Salvaste',
    see_your_inventory: 'Vê o teu inventário',
    you_bought: 'Compraste',
    order_details: 'Detalhes de compra',
    items_not_available: 'Infelizmente alguns dos itens no teu carrinho ficaram indisponíveis, por isso não pudeste comprá-los. Abaixo podes encontrar uma lista destes itens.',
    total_price: 'Preço total',
    withdraw_all_items: 'Levantar todos os itens',
    private_listing: 'Listagem privada {extra}',
    public_listing: 'Listagem pública {extra}',
    instant_sale_price: 'Preço de venda instantanea',
    not_accepted: 'Não aceite',
    not_available: 'Não disponível',
    no_sales_data: 'Sem informação de vendas',
    create_buy_order: 'Criar ordem de compra',
    active_buy_orders: 'As tuas ordens de compra ativas',
    buy_orders_history: 'Histórico de ordens de compra',
    market_buy_orders: 'Ordens de compra de mercado',
    recent_sales: 'Vendas recentes',
    selling_price: 'Preço de venda',
    sales_chart: 'Gráfico de vendas',
    sales_history_will_be_available_soon: 'Histórico de vendas Steam e BitSkins estará disponível em breve',
    souvenir: 'Lembrança',
    under: '{amount} e abaixo',
    above: '{amount} e acima',
    amount_to_amount: 'desde {amount1} até {amount2}',
    discount: 'Desconto',
    value_off_or_more: '{value}% off e mais',
    removed_items: 'Itens removidos',
    restore_all_items: 'Restaurar todos os itens',
    add_x_items_to_edit: 'Adicionar {amount} itens para edição',
    add_x_items_to_sale: 'Adicionar {amount} itens para venda',
    add_x_items_to_withdraw: 'Adicionar {amount} itens para levantamento',
    sell_x_items: 'Vender {amount} itens',
    withdraw_x_items: 'Levantar {amount} itens',
    first_you_need_to_select_an_item: 'Primeiro precisas de selecionar um item.',
    cheapest_price_on_bitskins: 'Preço mais baixo no BitSkins',
    final_price: 'Preço final:',
    check_quantity: 'Verificar quantidade',
    cancel_selected_orders: 'Cancelar ordens selecionadas',
    cancel_all_orders: 'Cancelar todas as ordens',
    community_rating: 'Classificação da Comunidade:',
    rating: 'Classificação',
    votes: 'votos',
    open_image: 'Abrir imagem',
    cheaper_than_steam_by_x: 'Mais barato que na Steam por {x}%',
    there_are_other_items_you_may_like: '<span>Há outros itens</span> que talvez possas gostar',
    available_variants: 'Variantes disponíveis',
    picture: {
      playside: 'Playside',
      backside: 'Backside',
      steam: 'Imagem do mercado Steam',
    },
    buy_orders_not_available: 'Ordens de compra indisponíveis neste momento',
    confirm_price_change: 'Confirmar alteração do preço',
    are_you_sure_to_change_price: 'Tens a certeza de que queres mudar o preço para <span class="text-cp fw-sb">{price}</span>?',
  },
  bumps: {
    heading: 'Gostarias de <span class="text-cp">vender os teus itens mais rapidamente</span> sem baixar o seu preço?',
    subheading: 'Temos algo para ti!',
    how_it_works: '<span class="text-cp">Como</span> funciona?',
    description: 'Na BitSkins temos uma opção de bumping que permite que listes os teus itens no mercado e noutras partes do website. É uma solução perfeita para alguém que quer acelerar o processo de vender itens sem ter de baixar o preço. Quando fazes bump de um item mais pessoas irão vê-lo e a chance de o venderes aumenta. Podes começar a fazer bumping nos teus itens com $0.75 ou ainda menos (por favor verifica o nosso pacote de bumping).',
    your_active_x_autobumps: 'Os teus {x} bumps automáticos',
    bumps_packages: 'Pacotes de bumps',
    bumps: 'bumps',
    bumps_title: 'Bumps',
    available_bumps: 'Bumps disponíveis',
    buy_selected_package: 'Comprar pacote selecionado',
    when_you_bump: 'Quando fizeres bump de um item irá aparecer nos seguintes sítios:',
    step_1_title: 'Na página do mercado na <span class="text-cp">barra superior</span>',
    step_2_title: 'Na página do mercado na <span class="text-cp">secção principal</span>',
    step_2_text: '(Apenas se a opção de organização estiver em "featured". Esta é a opção normal.)',
    step_3_title: 'Na <span class="text-cp">página inicial</span>',
    step_4_title: 'Na página de itens na secção de <span class="text-cp">itens semelhantes</span>',
    step_5_title: 'Na secção de <span class="text-cp">itens sugeridos</span>',
    after_bumping: '<span class="text-cp">Depois de fazeres bumping</span> num item ele será mostrado <span class="text-cp">no primeiro lugar</span> de cada secção. No entanto, <span class="text-cp">se alguém fizer bumping do seu item depois de ti</span> então o teu item será movido para o <span class="text-cp">segundo lugar</span>. O teu item estará visível em cada secção desde que não existam bumps suficientes para o tiraram da secção.',
    how_to_bump: '<span class="text-cp">Como fazer</span> bump do meu item?',
    how_to_1: 'Abre o menu do item',
    how_to_2: 'Seleciona a opção de <span class="text-cp">bump</span> ',
    how_to_3: 'Escolhe o tipo de bump',
    how_to_4: 'Feito!',
    table: {
      item: 'Item',
      quantity: 'Quantidade',
      left: 'Saiu',
      period: 'Período',
      created_at: 'Criado a',
      updated_at: 'Atualizado a',
      next_bump_at: 'Próximo bump a',
      action: 'Ação',
      status: 'Estado',
    },
    auto_enabled: 'Bump automático habilitado',
    auto_disabled: 'Bump automático cancelado',
    single_bumped: 'O item foi bumped',
  },
  buy_order: {
    confirm_buy_orders_cancellation: 'Confirma o <span class="color-primary">cancelamento das ordens de compra</span>',
    are_you_sure_that_you_want_to_cancel: 'Tens a certeza de que queres cancelar todas as tuas ordens de compra?',
    create_buy_order: 'Criar <span class="text-cp">ordem de compra</span>',
    predict_place_in_queue: 'Prever lugar na fila',
    your_place_in_the_queue: 'O teu lugar na fila:',
    may_purchase_items_with_trade_hold: 'Ordens de compra podem comprar itens com congelamento de troca.',
    create_a_buy_order_for_this_item: 'Criar uma ordem de compra para este item',
    no_buy_orders_found: 'Não foram encontradas ordens de compra',
    position_in_queue: 'Posição na fila',
    this_is_your_buy_order: '(esta é a tua ordem de compra)',
    skin_name: 'Nome da skins:',
    offers_on_market: 'ofertas no mercado',
  },
  instant_sell: {
    confirmation: 'Confirmação de venda instantanea',
    you_can_sell_x: 'Podes vender a AWP | Asiimov (Field-Tested) instantaneamente e receber $10.',
    the_funds_will_be_credited: 'Os fundos serão creditados na tua conta imediatamente. Se quiseres continuar clica em "Vender instantaneamente"',
  },
  sort: {
    select_option: 'Selecionar opção',
    apply: 'Aplicar',
    clear: 'Limpar',
    default_order_placeholder: 'Selecionar uma opção',
    select_order_placeholder: 'Selecionar ordenação',
    default_sort: 'Ordenação normal',
    custom_sort: 'Ordenação costumizada',
    field: {
      price: 'Preço',
      discount: 'Desconto',
      id: 'Data adicionada',
      bumped_at: 'Em destaque',
      suggested_price: 'Preço sugerido',
      asset_id: 'Data adicionada',
      float_value: 'Float',
      paint_index: 'Index de Pintura',
      paint_seed: 'Seed de Pintura',
      extras_1: 'Valor extra',
      extras_1_fade: 'Fade',
      amount: 'Quantidade',
      name: 'Nome',
    },
    order: {
      price: {
        asc: 'Mais barato primeiro',
        desc: 'Mais caro primeiro',
      },
      discount: {
        desc: 'Maior primeiro',
      },
      id: {
        asc: 'Mais antigo primeiro',
        desc: 'Mais recente primeiro',
      },
      asset_id: {
        asc: 'Mais antigo primeiro',
        desc: 'Mais recente primeiro',
      },
      bumped_at: {
        desc: 'Padrão',
        asc: '',
      },
      default: {
        asc: 'Menor primeiro',
        desc: 'Maior primeiro',
      },
    },
  },
  pagination: {
    showing: 'mostrando',
    to: 'para',
    of: 'de',
    records: 'recordes',
  },
  popups: {
    click_confirmation_link: 'Por favor verificar a tua caixa de email e clica no link de verificação para completar o processo.',
    steam_login_issue: {
      title: 'Problema com Login pela Steam',
      an_error_occured: 'Um erro ocorreu na tentativa de entrar com a Steam. Por favor tenta de novo.',
    },
    steam_inventory_private: {
      title: 'O teu inventário Steam é<span class="text-cp">privado</span> ',
      we_were: 'Não fomos capazes de carregar o teu inventário Steam. Por favor altera o estado para público.',
      you_can: 'Podes fazê-lo nas definições da Steam. Tem em atenção que pode demorar alguns minutos antes de detectarmos as mudanças.',
      steam_settings: 'Definições da Steam',
    },
    account_deletion_in_progress: {
      title: 'Eliminação de conta em progresso...',
      process_started: 'Começaste o processo de eliminação da conta.',
      account_will_be_deleted: 'A tua conta vai ser eliminada em',
      cancel_deletion: 'Cancelar eliminação',
      confirm_deletion: 'Confirmar eliminação',
      check_your_email: 'Verifica o teu email',
    },
    account_deletion_confirm: {
      title: 'Confirma eliminação da conta',
      subtitle: 'Tens a certeza de que queres eliminar a tua conta?',
      once_you_confirm: 'Depois de confirmares, serás automaticamente desconectado e toda a informação da tua conta será eliminada permanentemente dentro de tuas semanas. Durante estas duas semanas serás capaz de cancelar o processo de eliminação ao entrares na tua conta.',
      once_your_account_is: 'Uma vez que a tua conta é eliminada poderás criar uma nova conta na BitSkins ao entrar no websie.',
      however_you_will_not: 'Contudo, não terás acesso à informação eliminada.',
      if_you_want_to_continue: 'Se queres continuar clica em confirmar e clica no link de confirmação que te enviamos por email.',
      login: 'Precisas de entrar para confirmar a eliminação da tua conta',
      canceled: 'Eliminação de conta foi cancelada',
      confirmed: 'Eliminação de conta confirmada',
    },
    account_deletion_check_your_email: {
      title: 'Verifica o teu email',
      to_complete: 'Para completar o processo de eliminação de conta, clica no link de confirmação no email que te enviamos.',
    },
    twofa_enable: {
      already_done: 'Já habilitaste o 2FA.',
      setup_email_before: 'Para que consigas habilitar o 2FA precisas de definir o teu email primeiro.',
      twofa_authentication_adds: 'Autenticação de 2-Fatores (2FA) adiciona uma camada extra de segurança à tua conta ao necessitar de 2 métodos (fatores) para verificar a tua identidade. Habilitar 2FA é altamente recomendável para manter a tua conta segura, pois previne acessos indesejados sem acesso ao código 2FA adicional.',
      setup_twofa: 'Criar autenticação de 2-Fatores',
      if_you_dont_have_an_authenticator_app: 'Se tu <span class="text-cp">não tens</span> uma app de autenticação',
      we_recommend: '<p>Recomendamos o <a href="https://support.google.com/accounts/answer/1066447?hl=en" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Google Authenticator</a> ou <a href="https://authy.com/download/" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Authy</a> para Android ou IOS. Se queres usar a aplicação no teu computador podes descarregar e instalar o <a href="https://authy.com/download/" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Authy</a> ou usar a <a href="https://chrome.google.com/webstore/detail/authenticator/bhghoamapcdpbohphigoooaddinpkbai" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">extensão do Google Authenticator</a> no teu navegador.',
      scan_the_qr_code: '<span class="text-cp">Faz scan</span> do QR code',
      open_your_authenticator_app: 'Abre a tua aplicação de autenticação e faz scan do QR code ou digita a chave secreta manualmente',
      secret_key: 'Chave secreta',
      this_secret_key_will_be_valid_for_x_seconds: 'Esta chave secreta vai ser válida por <span class="text-cp">{x} @:{\'time.seconds\'}</span>.',
      save_this_secret: 'Guarda esta chave secreta num lugar seguro. Ela vai permitir que recuperes acesso aos teus códigos 2FA <br> quando perdes acesso à aplicação de autenticação.',
      enter_the_6_digit_code: 'Digita o <span class="text-cp">código de 6 digitos</span> gerado pela aplicação de autenticação',
      enter_code_from_the_email: 'Digita o código do <span class="text-cp">email</span>',
      enter_the_verification_code: 'Digita o código de verificação que enviamos para <span class="text-cp">{email}</span>.',
      desktop: 'Desktop',
    },
    twofa_enabled: {
      now_your_account_is: 'Agora a tua conta está protegida com autenticação de 2-Fatores',
      all_future_logins: 'Todos os acessos futuros irão agora precisar que digites o código fornecido pela tua aplicação de autenticação.',
    },
    twofa_enter_code: 'Digita o código 2FA gerado pela tua aplicação de autenticação.',
    twofa_disable: {
      title: 'Desabilitar 2FA',
      enter_the_6_digit_code: 'Digita o código de 6 dígitos gerado pela tua aplicação de autenticação.',
      cannot_access: 'Não consegues obter o teu código de verificação. Por favor contacta-nos em',
    },
    twofa_disabled: 'A tua conta já não está protegida com autenticação de 2-Fatores.',
    order_unable_to_process: {
      title: 'Não conseguimos <span class="text-cr">processar o teu pedido</span>',
      an_error_occurred: 'Ocorreu um erro enquanto processávamos o teu pedido.<br> Por favor volta para a página de checkout e tenta fazer o pedido de novo.',
      back_to_checkout: 'De volta ao checkout',
      back_to_item: 'De volta ao item',
      information: 'Se este erro ocorre com regularidade deves contactar-nos através da <a rel="nofollow noopener noreferrer" target="_blank" href="https://bitskins.com/support" class="text-cp">página de suporte</a> incluindo o código do erro:',
    },
    phone_number_add: {
      title: 'Adiciona o teu número de telemóvel',
      to_continue: 'Para continuar precisas de adicionar o teu número de telemóvel na tua conta',
      add_number: 'Adicionar número',
    },
    phone_number_confirmed: {
      title: 'Número de telemóvel confirmado',
      your_phone_number: 'O teu número de telemóvel foi confirmado.',
    },
    phone_number_verify: {
      title: 'Verifica o teu número de telemóvel',
      to_verify: 'Para verificares o teu numero de telemóvel tens de digitar o código de verificação que te enviamos',
      enter_sms_code: 'Digita o código SMS',
      you_cannot_update: 'Não podes atualizar o teu número de telemóvel neste momento. Poderás fazê-lo dentro de {minutes} minutos.',
    },
    phone_number_verification_in_progress: {
      title: 'Verificação de número de telemóvel em progresso',
      if_you_wish: 'Se quiseres podes atualizar o teu número de telemóvel ou reenviar o código de verificação.',
      send_code: 'Enviar código',
    },
    email_address_add: {
      your_email_address: 'O teu endereço de email',
      by_providing_my_email: 'Ao fornecer o meu endereço de email eu concordo em receber comunicações de marketing',
      verification_in_progress: 'Verificação de email em progresso ',
      to_verify: 'Para verificares o teu endereço de email precisas de clicar no link de confirmação no email que te enviamos',
      if_you_wish: 'Se quiseres podes atualizar o teu endereço de email ou reenviar o link de ativação.',
    },
    email_address_verify: {
      we_are_verifying: 'Estamos a verificar o teu endereço de email e pode demorar um bocado...',
      confirmed: 'O teu endereço de email foi confirmado.',
    },
    email_address_confirmed: {
      title: 'Endereço de email confirmado',
      your_email_address: 'O teu endereço de email foi confirmado.',
    },
    enter_your_trade_url: {
      title: 'Digita o teu <span class="text-cp">url de trocas</span>',
      to_continue: 'Para continuar primeiro precisas de fornecer o teu url de trocas. Irás encontrá-lo aqui',
      your_trade_url: 'O teu url de trocas',
    },
    password_reset_enter_email: {
      forgot: 'Esqueceste-te da tua',
      password: 'palavra-pass?',
      dont_worry: 'Não te preocupes, digita o teu endereço de email abaixo.',
      we_will_send: 'Vamos enviar-te um link para recuperares a tua palavra-pass.',
      send_reset_link: 'Enviar link de recuperação',
      if_this_email: 'Se este email estiver associado com uma conta da BitSkins,',
      you_will_receive: 'irás receber um email com o link de recuperação da tua palavra-pass',
    },
    password_reset_new_password: {
      enter_your: 'Digita a tua',
      new_password: 'nova palavra-pass',
      enter_password: 'Digita a palavra-pass',
      repeat_password: 'Repete a palavra-pass',
      save_password: 'Guardar palavra-pass',
    },
    link_expired: {
      title: 'Link expirado',
      the_process_cannot: 'Este processo não pode ser completado. O link já expirou.',
      go_to_settings: 'Ir para as definições',
    },
    wrong_link: {
      title: 'Link errado',
      we_were_unable: 'Não conseguimos processar o teu pedido. Seguiste um link errado',
    },
    trade_preparing: {
      title: 'Estamos a preparar a tua oferta de troca',
      processing: 'Pode demorar alguns segundos...',
    },
    trade_sent: {
      trade_offer_has_been_sent: 'A tua oferta de troca foi <span class="text-cp">enviada</span>',
    },
    trade_done: {
      title: 'Oferta de troca foi <span class="text-cp">aceite</span>',
      listed: 'Anunciaste com sucesso os teus itens para venda. Podes geri-los na <a rel="nofollow noopener noreferrer" href="https://bitskins.com/selling" class="text-cp">tabela de vendas</a>. ',
      see_listed: 'Vê os teus itens anunciados',
      withdrawn: 'Levantaste com sucesso os teus itens.',
    },
    trade_declined: {
      your_trade_offer_has_been: 'A tua oferta de troca foi',
      declined: 'recusada',
      if_you: 'Se não a recusaste significa que alguém está a usar a tua conta e os teus itens podem estar em risco de roubo.',
      to_stay: 'Para proteger os teus itens age com rapidez e segue estes passos:',
      step_revoke: 'Revoga a tua Chave API da Steam Web.',
      step_revoke_btn: 'REVOGAR CHAVE API',
      step_password: 'Muda a tua palavra-pass da Steam',
      step_password_btn: 'MUDAR PALAVRA-PASS',
      step_deauth: 'Desautoriza todos os dispositivos na Steam.',
      step_deauth_btn: 'DESAUTORIZAR DISPOSITIVOS',
      step_trade: 'Cria um novo URL de trocas.',
      step_trade_btn: 'CRIAR NOVO URL DE TROCAS',
      step_new: 'Define o teu novo Link de trocas na BitSkins.',
      step_new_btn: 'DEFINIR NOVO URL DE TROCAS',
      step_try: 'Tenta depositar os teus itens de novo e verifica se o problema persiste. ',
      step_try_if: 'Se continuar a acontecer, para todas as trocas e contacta o suporte.',
      contact_support: 'Contactar o suporte',
      information: 'Tem em conta que os nossos membros da staff e bots nunca irão pedir por quaisquer depósitos via Steam Chat, Discord ou em qualquer outro sítio - qualquer um que se identifique como um admin, etc... é falso e o mais provável é querer roubar-te. Tem cuidado!',
    },
    trade_failed: {
      offer_failed_title: 'Oferta de troca <span class="text-cr">falhada</span>',
      offer_failed_text: 'Infelizmente a tua oferta de troca falhou. Por favor tenta de novo.',
      offer_failed_to_create_title: '<span class="text-cr">Falha ao</span> criar oferta de troca',
      offer_failed_to_create_text: 'Infelizmente não fomos capazes de criar a tua oferta de troca. Por favor tenta de novo.',
      contact_support: 'Se este erro ocorre com frequência deves contactar-nos através da <a rel="nofollow noopener noreferrer" target="_blank" href="https://bitskins.com/support" class="text-cp">página de suporte</a>.',
      support_page: 'página de suporte',
      cannot_process: 'Não conseguimos processar a tua oferta de troca',
      unfortunately_we_were_unable: 'Infelizmente, não conseguimos processar a tua oferta de troca. O mais certo é já teres uma oferta de troca ativa por estes itens.',
    },
    items_not_available: {
      title: 'Itens já não estão mais disponíveis para venda',
      unfortunately: 'Infelizmente os itens do teu carrinho já <span class="text-cy-secondary">não estão disponíveis para venda</span>.',
      dont_worry: 'Não te preocupes, podes encontrar imensos itens na página de mercado.',
      unavailable_items: 'Itens indisponíveis',
      back_to_market: 'De volta ao mercado',
    },
    bump_purchase_confirmation: {
      title: 'Confirmação de compra',
      do_you_want_to_purchase: 'Queres comprar <span class="text-cp">{quantity} bumps</span> por<span class="text-cp">{price}</span>?',
      bumps_package: 'pacote de bumps',
    },
    bump_start: {
      title: 'Faz bump no teu item',
      bump_your_item: 'Faz bump no teu item para o destacares na página de mercado e em alguns outros sítios no website. <br>Isto pode ajudar-te a vender o teu item mais rapidamente pois será visto por mais pessoas. <br>Se queres saber mais sobre o funcionamento dos bumps',
      click_here: 'clica aqui',
      single_bump: 'Um único bump',
      autobumps: 'Bumps automáticos',
      one_bump: '1 bump',
      this_option_single_bump: 'Esta opção vai fazer bump do teu item uma vez e custa <span class="text-cp">$0.75</span>. Se já tens bumps disponíveis na tua conta então nada será cobrado do teu saldo.',
      this_option_autobumps: 'Esta opção vai fazer bump do teu item a cada período selecionado. Se já tens bumps disponíveis na tua conta então nada será cobrado do teu saldo. Se acabares os teus bumps então <span class="text-cp">$0.75</span> vão ser cobrados do teu saldo a cada bump. <span class="text-cp">Podes comprar mais bumps antecipadamente</span> e ao mesmo tempo <span class="text-cp">salvar algum dinheiro</span> - desliza para baixo para ver os pacotes de bumps.',
      bump_every: 'Bump a cada',
      bumps_amount: 'Quantidade de bumps',
      delayed_start: 'Começo atrasado',
      delayed_start_description: 'Ao verificares esta opção o teu primeiro bump vai ser atrasado pelo período de tempo selecionado.',
    },
    bump_stop: {
      title: 'Parar bumps automáticos',
      do_you_want: 'Queres parar com os bumps automáticos para este item?',
    },
    bulk_buy: {
      bulk_buy: '<span class="text-cp">Compra</span> em volume',
      maximum_items_you_can_buy: 'Máximo de itens que podes comprar por este preço:',
      may_purchase_items_with_trade_hold: 'Opção de compra em volume pode comprar itens com congelamento de troca.',
    },
  },
  affiliate: {
    ad_info: 'Se não vês a caixa, por favor tenta desabilitar o adblock.',
    affiliate_code: 'Código de afiliado',
    affiliate_link: 'Link de afiliado',
    level: 'Nível',
    levels: 'Níveis de <span class="text-cp">afiliado</span>',
    our_levels: 'Os nossos níveis',
    your_code: 'O teu código de <span class="text-cp">afiliado</span>',
    your_affiliate_statistics: 'As estatísticas dos <span class="text-cp">teus afiliados</span> ',
    earn_money_by_simply_sharing: '<span class="text-cp">Recebe dinheiro</span> por apenas partilhares o teu amor pela BitSkins com a tua audiência!',
    percent_from_sale_fee: '{value}% da taxa de venda',
    join_the_bitskins_affiliate: 'Junta-te ao pograma de afiliados da BitSkins e ganha comissões por cada venda feita através do teu link de afiliado. Quer tenhas um vasto número de seguidores ou apenas alguns amigos, quanto mais partilhares, mais ganhas.',
    tile_1_title: 'Partilha a BitSkins com a tua audiência',
    tile_1_description: 'Cria o teu próprio link de afiliado em segundos e começa a partilhá-lo com os teus amigos e audiência',
    tile_2_title: 'Vê os teus lucros crescerem',
    tile_3_title: 'Reivindica os teus ganhos',
    tile_3_description: 'Fundos obtidos pelo pograma de afiliado podem ser gastos ao comprar itens ou podem ser levantados. Tu escolhes!',
    kyc_you_cannot_use: 'Não podes usar o sistema de afiliado porque não finalizaste o procedimento do KYC. Podes começar o processo de verificação agora.',
    your_percentage: 'A tua percentagem',
    generated: 'Gerado',
    individual_affiliate_program: 'Programa de afiliados individual',
    if_you_or_your_business: 'Se tu ou o teu negócio estão envolvidos na indústria de esports ou geram um largo alcance nas redes sociais, por favor contacta-nos via <span>partnership{\'@\'}bitskins.com</span>. Podemos oferecer-te condições de afiliado individuais.',
    invited_referrals: 'Referências convidadas',
    active_referrals: 'Referências ativas',
    your_percentage_sales_fee: 'A percentagem da tua taxa de vendas',
    your_total_earnings: 'Os teus ganhos totais',
    available_earnings: 'Ganhos disponíveis',
    you_can_claim_your_earnings_one_a_day: 'Podes reivindicar ganhos uma vez por dia. Depois de os reivindicares eles irão aparecer no teu saldo para levantamento em 24 horas. Quantidade mínima para pagamento é',
    to_reach_the_next_level: 'Para chegar ao próximo nível e receber comissões maiores, precisas de gerar <span class="text-cp">{x}</span> em vendas através das tuas referências.',
    any_user_that_registers_from_your_affiliate_link: 'Qualquer utilizador que se registre com o teu link de afiliado irá ser automaticamente designado como teu referenciado ',
    my_earnings: '<span class="text-cgs">Os meus</span> ganhos',
    referred_users: 'Utilizadores <span class="text-purple">referidos</span>',
    code_updated: 'Código de afiliado atualizado com sucesso',
    not_enough_money: 'Sem dinheiro suficiente para transferência',
    account: 'Conta',
    referrals_sales: 'Histórico de vendas de referências',
  },
  profile: {
    hi: 'Olá',
    nav: {
      account: 'Conta',
      wallet: 'Carteira',
      transactions: 'Transações',
      statistics: 'Estatísticas',
      affiliate: 'Afiliado',
      company: 'Companhia',
      trades: 'Trocas',
      items_history: 'Histórico de itens',
    },
    top_star: {
      you_are: 'És uma',
      top_star: 'TOP STAR',
      good_to_see_you: 'Olá "{username}", é bom ver-te na BitSkins!',
      appreciate_using: 'Nós agradecemos que tenhas decidido usar a nossa plataforma,',
      extra_settings: 'por isso preparámos algumas definições extra para ti.',
      show_nickname_selling: 'Mostrar o meu nome de utilizador na página de itens enquanto vendo',
      show_nickname_store: 'Destacar o meu nome de utilizador na página da loja',
    },
    basic: {
      basic_information: 'Informação básica',
      username: 'Nome de utilizador',
      change_username: 'Mudar nome de utilizador',
      registration_date: 'Data de recuperação',
      email: 'Email',
      change_email: 'Mudar email',
      password: 'Palavra-pass',
      change_password: 'Mudar palavra-pass',
      phone: 'Número de telemóvel',
      change_phone: 'Mudar número de telemóvel',
      hide_balance: 'Esconder o teu saldo',
      hide_balance_description: 'A quantidade de fundos será escondida do teu cabeçalho, será visível após clicares na carteira.',
    },
    security: {
      you_can_access_your_account: 'Podes entrar na tua conta através de uma chave API. A nossa documentação API está localizada',
      api_status: 'Estado API',
      security: 'Segurança',
      twofa: 'Autenticação de 2-Fatores',
      temporarily_block_my_account: 'Bloquear a minha conta temporariamente',
      temporarily_block_title: '<span class="text-cr">Bloquear a minha conta</span> temporariamente',
      temporarily_block_description: 'Se acreditas que a tua conta foi comprometida pode bloqueá-la temporariamente.\nNós vamos desbloquear a tua conta depois de contactares o nosso suporte.',
      temp_blocked: 'A tua conta foi bloqueada temporariamente.\nPor favor contacta o nosso suporte para clarificar esta situação.',
      block_my_account: 'Bloquear a minha conta',
      delete_account: 'Eliminar a conta',
      delete_my_account: 'Eliminar a minha conta',
      sessions: 'Sessões',
      close_all_sessions: 'Fechar todas as sessões',
      current_session: 'Sessão atual',
      active_sessions: 'Sessões ativas',
      no_other_sessions: 'Sem outras sessões',
      removed: 'Removido',
      online: 'Online',
      api_key: 'Chave API',
      api_key_not_available: 'A chave API é apenas visível uma vez durante a sua criação',
      sensitive_hidden: 'Informação sensível escondida',
      ip_whitelist: 'Lista branca de IPs',
      add_ip_to_whitelist: 'Adicionar IP à lista branca',
      disable_api_confirm: 'Confirmar desabilitação de acesso API',
      disable_api_content: 'Tens a certeza que queres desabilitar o acesso API da tua conta?',
    },
    store: {
      my_store: 'A minha loja',
      store: 'loja',
      store_url: 'Url da loja',
      store_alias: 'Apelido da loja',
      id_store: 'ID DA LOJA',
      hide_store: 'Esconder a página da tua loja',
      url_copied: 'Url da loja copiado',
      total_items: 'Total de itens:',
      games: 'Jogos:',
    },
    setting: {
      account_email: 'Email da conta',
      update_email: 'Atualizar email',
      setup_email: 'Definir email',
      update_password: '<span class="text-cp">Atualizar</span> palavra-pass',
      set_password: '<span class="text-cp">Definir</span> palavra-pass',
      enter_current_password: 'Digitar palavra-pass atual',
      password_changed: 'Palavra-pass alterada',
      current_password: 'Palavra-pass atual',
      enter_new_password: 'Digitar nova palavra-pass',
      repeat_new_password: 'Repetir nova palavra-pass',
      save_new_password: 'Guardar nova palavra-pass',
      new_password: 'Nova palavra-pass',
      repeat_password: 'Repetir palavra-pass',
      account_2fa: '2FA da Conta',
      enable_2fa: 'Habilitar 2FA',
      disable_2fa: 'Desabilitar 2FA',
    },
    transaction: {
      amount: 'Quantidade',
      type: 'Tipo',
      details: 'Detalhes',
      fee: 'Taxa',
      buyer_country: 'País do comprador',
      seller_country: 'País do vendedor',
      price: 'Preço',
      item_name: 'Nome do item',
      transaction_history: 'Histórico de transações',
      operation: 'Operação',
      trade_id: 'ID de trocas',
      loading_trade_offers: 'A carregar ofertas de troca',
      no_trades_found: 'Sem ofertas de troca encontradas',
      id: 'ID',
      date: 'Data',
      game: 'Jogo',
      items: 'Itens',
      status: 'Estado',
      time_left: 'Tempo restante',
      action: 'Ação',
      trades_active: 'Trocas ativas',
      trades_history: 'Histórico de trocas',
      balance: 'Saldo',
      history: 'Histórico de transações',
      pending: 'Transações pendentes',
      reports: 'Relatórios exportados',
      active_locks: 'Bloqueios ativos',
      export: 'Exportar',
      export_to_csv: 'Exportar para .CSV',
      export_description: 'Seleciona o mês e ano nos quais queres gerar o relatório',
      the_report_will_appear_in_the: 'O relatório irá aparecer na',
      tab_once_the_export_process_is_complete: 'janela assim que processo de exportação esteja completo.',
    },
  },
  fee: {
    individual: 'individual',
    individual_fee: 'taxa individual',
    custom_sale_fee: 'A tua taxa de venda personalizada',
    your_current_fees: 'As tuas taxas atuais',
    high_tier: 'Nível alto',
    fee: 'Taxa',
    fee_up_to: 'taxa',
    sale_fee: 'Taxa de venda',
    sales_fees: 'Taxas de vendas',
    see_all_levels: 'Ver todos os níveis',
    you_are_on_the: 'Estás no',
    maximum_sales_fee: 'Taxa máxima de vendas: {value}',
    your_total_sale_volume: 'O volume total das tuas vendas até agora',
    sales_fees_will_be_lowered: 'Taxas de vendas são reduzidas quantos mais itens venderes.',
    level: 'nível',
    your_level: 'O teu nível:',
    progress: 'Progresso:',
    max_level: 'Nível máximo',
    next_level: 'Próximo nível:',
    total_income: 'Renda total',
    total_revenue: 'Receita total',
    sold_items: 'Itens vendidos',
    page: {
      sales_fees_depends_on_two_factors: 'Na BitSkins as <span class="text-cp">TAXAS DE VENDAS</span> dependem de dois fatores:',
      the_price: '1. O preço a que estás a vender um item',
      the_listing_type: '2. O tipo de listagem:',
      listing_type_public: 'Público  o teu item é visível para todos os utilizadores do website',
      listing_type_private: 'Privado - o teu item é visível apenas para as pessoas com quem partilhaste o link',
      fee_explanation: 'Quanto mais alto for o preço a que vendes o teu item, menor será a taxa de venda que irás pagar. A taxa de venda padrão vai desde 2.5% (para listagens privadas) até um máximo de 10% (para listagens públicas). Em adição, nós temos 5 níveis de vendas diferentes que permitem que baixes as tuas taxas de venda ainda mais. A regra é simples - quanto mais venderes, menores taxas pagas. Podes reduzir as tuas taxas de vendas até 2.4% (para listagens privadas) ou até 9.8% (para listanges públicas). O nosso sistema de taxas é transparente e não existem taxas ocultas.',
      default_sales_fees_title: 'Taxas de vendas <span class="text-cp">padrão</span>',
      default_sale_fees_description: 'Se estás apenas a começar e ainda não vendeste itens então as tuas taxas de vendas serão as seguintes:',
      how_to_reduce_my_sales_fees_title: '<span class="text-cp">Como reduzir</span> a minha taxa de venda?',
      how_to_reduce_my_sales_fees_description: 'Na BitSkins temos 5 níveis de vendas. Cada um (exceto o Nível 1) reduz a tua taxa de venda por 0.05%. Para evoluir o teu nível, precisas de vender itens até um determinado valor.',
      sales_fees_levels: '<span class="text-cp">Níveis de taxas</span> das vendas',
      price_range: 'Faixa de preço',
      total_sales: 'Vendas totais',
      fee_reduced_by: 'Taxa reduziar por',
      individual_sales_fees_title: 'Taxas de vendas individuais ',
      individual_sales_fees_description: 'Se estás ativamente a usar a BitSkins e se o teu volume de negócios mensal é de pelo menos <span class="span text-csfl6">{amount}</span>, não hesites em contactar-nos. Podemos oferecer-te<span class="text-csfl6">ainda menores taxas de venda</span> e <strong>assistência adicional</strong>.',
    },
  },
  copy: {
    text_copied: 'Texto copiado',
    cannot_copy: 'Não podes copiar',
    name_copied: 'Nome copiado',
    cannot_copy_name: 'Não podes copiar o nome',
    copy_link: 'Copiar link',
  },
  share: {
    share_on_twitter: 'Partilhar no Twitter',
    share_on_facebook: 'Partilhar no Facebook',
    share_on_telegram: 'Partilhar no Telegram',
  },
  discord: {
    discord: 'Discord',
    already_connected: 'Já conectado',
    something_went_wrong: 'Algo correu mal',
    success: 'Sucesso',
    loading: 'A carregar...',
    connect_with_discord: 'Conectar com o Discord',
  },
  telegram: {
    already_connected: 'Já conectado',
    something_went_wrong: 'Algo correu mal',
    success: 'Sucesso!',
    loading: 'A carregar...',
  },
  error: {
    error_404: 'Erro 404',
    page_not_found: 'Página não encontrada',
  },
  kyc: {
    description_1: 'Para assegurar a segurança das transações levadas a cabo no nosso website e para ir de acordo com os regulamentos AML/KYC, nós exigimos que faças o processo de verificação (KYC). Há três níveis de verificação. Cada nível aumenta ou remove completamente limites e dá-te acesso a novos métodos de pagamento.',
    description_2_start: 'Termos e Condições detalhados à cerca do processo de verificação KYC são descritos nos nossos Termos de Serviço. Gostaríamos de assegurar que toda a informação fornecida por ti será usada em acordo com o',
    description_2_end: 'Ao iniciar o processo de verificação KYC, consentes em que a tua informação seja processada por nós para fins legais justificáveis.',
    personal_data: 'Dados pessoais',
    first_name: 'Primeiro nome',
    middle_name: 'Nome do meio',
    last_name: 'Último nome',
    street_name: 'Nome da rua',
    street_number: 'Número da rua',
    postal_code: 'Código Postal',
    city: 'Cidade',
    province: 'Província',
    country: 'País',
    start_kyc_verification: 'Começar verificação KYC',
    upload: 'Carregar',
    uploaded: 'Carregado',
    image_uploaded: 'imagem carregada',
    document_type: {
      id: 'ID',
      driving_license: 'Carta de Condução',
      passport: 'Passaporte',
      other: 'Outro',
    },
    limit: {
      crypto_withdraw: 'Limite anual de levantamentos crypto de {amount}',
      crypto_withdraw_unlimited: 'Levantamentos crypto ilimitados',
      non_crypto_withdraw: 'Limite anual de levantamentos non-crypto de {amount}',
      non_crypto_withdraw_unlimited: 'Levantamentos non-crypto ilimitados',
      crypto_deposit: 'Limite anual de depósitos crypto de {amount}',
      crypto_deposit_unlimited: 'Depósitos crypto ilimitados',
      non_crypto_deposit: 'Limite anual de depósitos non-crypto de {amount}',
      non_crypto_deposit_unlimited: 'Depósitos non-crypto ilimitados',
    },
    your_kyc_verification: 'A tua verificação KYC',
    your_kyc_needs_an_update: 'O teu KYC precisa de <span class="color-update">um update</span>',
    need_update_reason: 'Infelizmente não fomos capazes de aprovar a tua conta devido às seguintes razões:',
    open_support: 'Abre o suporte',
    your_kyc_has_been_denied: 'O teu KYC foi <span class="color-denied">negado</span>',
    denied_description: 'O teu KYC foi negado, por isso não podes fazer o processo de verificação de novo.',
    deleted_description: 'O teu KYC foi negado. Podes fazer o processo de verificação de novo.',
    please_contact_our: 'Por favor contacta o nosso',
    support: 'suporte',
    clarify_the_situation: 'para clarificar a situação.',
    your: 'A tua',
    kyc_title: '<span class="text-cp">verificação</span> de Know Your Costumer',
    verification: 'verificação',
    pending: 'está pendente',
    pending_description: 'É tudo! Obrigado por teres feito o processo de verificação. A tua informação foi submetida com sucesso. Nós vamos fazer o nosso melhor para verificar a tua aplicação assim que possível. Normalmente não demora mais que 12 horas. Vamos enviar-te um email assim que a tua conta for aprovada. Agradecemos pela tua paciência.',
    do_you_need_help: 'Precisas de ajuda? Por favor contacta o nosso',
    support_center: 'centro de suporte',
    back_to_kyc: 'De volta ao KYC',
    go_to_home: 'Ir para casa',
    level_0: 'Nível 0',
    level_1: 'Nível 1',
    level_2: 'Nível 2',
    limits: 'Limites',
    benefits: 'Benefícios',
    requirements: 'Requerimentos',
    no_requirements: 'Sem requerimentos',
    proof_of_address: 'Prova de morada',
    all_benefits_from_the_basic_level: 'Todos os benefícios do nível básico',
    personal_information: 'Informação pessoal',
    identity_document: 'Documento de identificação',
    selfie: 'Selfie',
    all_benefits_from_level_1: 'Todos os benefícios do nível 1',
    current: 'Atual',
    upending: 'Pendente',
    update: 'Atualizar',
    verification_blocked: 'Verificação bloqueada',
    verify_now: 'Verificar agora',
    you_need_to_upgrade_to_level_1: 'Precisas de evoluir para o nível 1',
    upgrade_to_level_1: 'Evoluir para o nível 1',
    upgrade_to_level_2: 'Evoluir para o nível 2',
    kyc_verification: 'Verificação KYC',
    kyc_verification_span: 'Verificação <span class="color-primary">KYC</span>',
    kyc_verification_required: 'Verificação KYC necessária',
    everything_done: 'Tudo feito!',
    proof_of_residency: 'Prova de residência',
    you_current_residential_address: 'A tua morada residencial atual',
    only_x_minutes: 'Apenas {minutes} minutos!',
    identity_verification: 'Verificação de identidade',
    take_a_selfie: 'Tirar uma selfie',
    step: 'Passo {step}',
    country_of_residence: 'País de residência',
    full_name: 'Nome completo',
    date_of_birth: 'Data de nascimento',
    nationality: 'Nacionalidade',
    choose_your_document: 'Escolhe o teu documento',
    choose_document_description_1: 'Escolhe o documento que queres usar durante a verificação.',
    choose_document_description_2: 'Só aceitamos documentos válidos emitidos pelo Estado.',
    choose_document_description_3: 'Quaisquer outros documentos que não estejam na lista serão rejeitados.',
    document_number: 'Número do documento',
    country_of_issue: 'País de emissão',
    document_issue_date: 'Data de emissão de documento',
    document_expiry_date: 'Data de expiração de documento',
    files_requirements: 'Requerimentos de ficheiros',
    format: '{format} ou {or} formato',
    maximum_file_size: 'Tamanho máximo de ficheiro {size}',
    minimum_picture_size: 'Tamanho mínimo de imagem {size} pixéis ',
    not_accepted_documents: 'Documentos não aceites',
    expired: 'Expirado',
    edited: 'Editado',
    black_and_white: 'Preto e branco',
    broken_or_damaged: 'Partido ou estragado',
    illegible_blurred_or_reflective: 'Ilegível, desfocada ou com reflecção ',
    cut_off_or_overcropped: 'Cortada ou supercultivada',
    upload_front_page: 'Carregar página dianteira',
    upload_back_page: 'Carregar página traseira',
    selfie_description: 'Por favor carrega uma foto de ti próprio a segurar o teu ID e um papel com o teu nome, o texto "BitSkins.com" e a data de hoje.',
    example_of_correctly_taken_photo: 'Um exemplo de uma foto tirada atualmente',
    with_sunglasses_cap_or_mask: 'Com óculos de sol, chapéu ou máscara',
    information_covered_by_finger: 'A informação no teu documento está tapada com os teus dedos',
    face_covered_by_document: 'A tua cara está tapada com o teu documento',
    out_of_focus: 'A tua cara ou o teu documento estão fora do foco',
    upload_selfie: 'Carregar selfie',
    send_level_1_kyc_request: 'Enviar pedido de KYC nível 1',
    address_line_1: 'Linha de Morada 1',
    address_line_2_optional: 'Linha de Morada 2 (opcional)',
    state_or_province: 'Estado ou Província',
    proof_of_residency_description: 'Por favor carrega documentos que provem a morada residencial atual que forneceste no passo anterior. Garante que o teu nome completo está visível nesse documento.',
    upload_document: 'Carregar documento',
    accepted_documents: 'Documentos aceites',
    utility_bills: 'Contas de serviços públicos',
    bank_statements: 'Extratos bancários',
    tax_returns: 'Declarações fiscais',
    government_letters: 'Cartas do Estado',
    other_document_residential: 'Outros documentos que confirmam a tua morada residencial atual',
    send_level_2_kyc_request: 'Enviar pedido de KYC nível 2',
    submit: 'Enviar',
    submit_correct: 'Enviar informação atual',
    next: 'Próximo',
    send_to_verify: 'Enviar para verificar',
    document_verification: 'Verificação de documentos',
    level: 'Nível KYC',
    please_reupload_following_photos: 'Por favor reenvia as seguintes fotos',
    please_reupload: 'Por favor reenvia',
    we_need_additional_information: 'Precisamos de informação adicional',
    file_format_not_supported: 'O formato do ficheiro não é suportado',
    the_file_is_too_big: 'O ficheiro {file_name} é demasiado grande ({file_size}), <br> o máximo é {size_limit}.',
    field: {
      document_image_a: 'Página dianteira do teu documento',
      document_image_b: 'Página traseira do teu documento',
      user_image: 'A tua selfie',
      address_image: 'Prova de residência',
      additional_selfie: 'Selfie adicional',
    },
    back_to_bitskins: 'De volta à BitSkins',
    withdrawals: 'Levantamentos',
    get_to_the_next_level: 'Vai para o próximo nível para te veres livre de <br>limites e ganhares acesso a <br> novos métodos de pagamento.',
    after_the_first_page_is_validated: 'Depois da primeira foto ser validada poderás enviar a segunda foto.',
    accepted: 'Aceite',
  },
  camera: {
    cancel: 'Cancelar',
    check_permissions: 'Verificar permissões',
    take_a_new_photo: 'Tirar uma foto nova',
    take_a_photo: 'Tirar uma foto',
    use_camera: 'Usar câmara',
    use_photo: 'Usa foto',
    we_will_need_access_to_your_camera: 'Vamos precisar de acesso à tua câmara para continuar.',
    please_follow_these_steps: 'Por favor segue estes passos',
    select_the_camera_icon: 'Seleciona o <strong>icon da câmara</strong> na tua barra de endereços',
    select_always_allow_access: 'Seleciona <strong>Permite sempre que tenha acesso à tua câmara</strong>',
    select_done: 'Seleciona <strong>Feito</strong>',
  },
  review: {
    leave_a_review: 'Deixa uma avaliação',
    our_reviews: 'As nossas avaliações',
    if_youre_happy: 'Se <span class="color-primary">estás feliz</span> com o serviço,',
    we_would_appreciate: 'Agradecíamos se pudesses deixar-nos uma <span class="color-primary">avaliação no Trustpilot</span> partilhando a tua experiência de forma a ajudar-nos. Obrigado!',
    if_youre_happy_we_would_appreciate: 'Se <span class="color-primary">estás feliz</span> com o nosso serviço, agradecíamos se pudesses deixar-nos uma <span class="color-primary">avaliação no Trustpilot</span> partilhando a tua experiência para nos ajudar. Obrigado!',
  },
  support: {
    center: 'Centro de suporte',
    tickets_list: 'Lista de tickets',
    create_ticket: 'Criar ticket',
    submit_ticket: 'Enviar ticket',
    close_ticket: 'Fechar ticket',
    submit_disclaimer: 'Para acelerar o nosso trabalho e para receberes uma resposta o mais rápido possível, não abras múltiplos tickets sobre o mesmo problema. O tempo médio de resposta é de <strong>algumas horas</strong>. Podes contactar-nos em <strong>Inglês, Polaco e Sueco</strong>. Obrigado pela tua cooperação.',
    enter_your_message: 'Digita a tua mensagem',
    new_ticket: 'Novo ticket',
    your_ticket: 'O teu ticket',
    bitskins_team: 'Equipa BitSkins',
    ticket_has_been_closed_by: 'O ticket foi <span>fechado</span> por <span>{by}</span>',
    ticket_has_been_closed: 'O ticket foi <span>fechado</span>',
    conversation_history: 'Histórico de conversação',
    your_reply: 'A tua resposta',
    last_reply_by: 'Última resposta por',
    send: 'Enviar',
    ticket: 'Ticket',
    title: 'Título',
    category: {
      payments: 'Pagamentos',
      payment_crypto_deposit: 'Depósito Crypto',
      payment_crypto_withdraw: 'Levantamento Crypto',
      payment_standard_deposit: 'Método de depósito padrão',
      payment_standard_withdraw: 'Método de levantamento padrão',
      market: 'Mercado',
      market_item_issue: 'Problema de item',
      market_buy_orders: 'Ordem de compra',
      market_bulk_buy: 'Compra em volume',
      market_missing_screenshot: 'Captura de ecrã em falta',
      market_missing_float: 'Float em falta',
      market_wrong_price: 'Preço Steam errado',
      market_other: 'Outro',
      trading: 'Trocas',
      trading_deposit: 'Depósito de item',
      trading_withdraw: 'Levantamento de item',
      account: 'Conta',
      account_2fa: 'Problema de 2FA',
      account_email: 'Problema de email',
      account_kyc: 'KYC',
      account_affiliate: 'Sistema de afiliados',
      account_restrictions: 'Restrições',
      account_other: 'Outro',
      other: 'Outro',
      bug_report: 'Relatório de erro',
      api: 'API',
      suggestions: 'Sugestões',
      business_inquiry: 'Inquérito de Negócios',
      general_inquiry: 'Inquérito Geral',
    },
    extra: {
      txid_url: 'TXID/url',
      amount: 'Quantidade',
      crypto: 'Criptomoeda ',
      disclaimer_visa_1: 'Por favor tem em atenção, é normal que possa demorar 5 dias úteis para que o teu dinheiro esteja disponível na tua conta bancária.',
      disclaimer_visa_2: 'Por favor garante que é um cartão VISA e não Mastercard para o qual estás a tentar levantar. De momento não suportamos levantamentos para cartões Mastercard.',
      card_digits: '4 últimos dígitos do teu cartão',
      binance_id: 'O teu ID Binance',
      wallet_address: 'Endereço de carteira',
      provider: 'Fornecedor',
      transaction_id: 'ID de Transação',
      type: 'Tipo',
      method: 'Método',
      item_link: 'Link para o item',
      bot_received_item: 'Um link do perfil do bot que recebeu os teus itens',
      trade_offer_id: 'ID da oferta de troca',
      can_be_found_here: 'pode ser encontrado aqui',
      email: 'Digita o email',
    },
  },
  service: {
    market: {
      buy: 'Comprar',
      sell: 'Vender',
      fee: 'Taxa de venda',
      buy_order: 'Ordem de compra',
      bargain: 'Barganha',
      instant_sell: 'Venda instantânea',
      bump: 'Bump',
      bump_package: 'Pacote de bumps',
    },
    deposit: {
      gift_code: 'Código de presente',
      bitcoin: 'Depositar BTC',
      litecoin: 'Depositar LTC',
      ethereum: 'Depositar ETH',
      unlimint: 'Depositar com cartão bancário',
      binance_pay: 'Depositar com Binance Pay',
      binancepay: 'Depositar com Binance Pay',
      available_coupons: 'Cupões disponíveis:',
      redeem_coupon: 'Resgatar cupão',
      enter_coupon_code: 'Digitar o código de cupão',
      open_binance_website: 'Abrir o website da Binance',
      list_of_active_transactions: 'Lista de transações ativas:',
      transaction_needs_at_least_x_confirmations: 'Transação precisa de pelo menos {x} confirmações para que os fundos apareçam na tua conta.',
      billing_information: 'Informação de <span class="text-cp">Faturação</span>',
      coupon: {
        coupon: 'Cupão',
        make_a_gift: 'Faz <span class="text-cp">um presente</span> para ti ou para outra pessoa',
        bitskins_coupons_are_a_good_alternative: 'Cupões da BitSkins são uma boa alternativa para métodos de pagamento padrão e uma ótima ideia de presente. Podes comprá-los nos nossos parceiros que oferecem muitos métodos de pagamento.',
        dont_wait: '<span class="text-cp">Não esperes e enche o teu saldo</span> com um cupão BitSkins ou faz<br> <span class="text-cp">um presente original</span> para alguém (todos conhecemos alguém com um inventário vazio)',
        kinguin: 'Kinguin (novas e menores taxas)',
      },
      crypto: {
        get_wallet_address: 'Obter endereço de carteira',
        your_wallet_address: 'O endereço da tua carteira',
        this_address_is_only_for_x: 'Este endereço é apenas para {x} depósitos. Não envies qualquer outra crypto para este endereço.',
        this_address_will_not_expire: 'Este endereço não vai expirar. Podes usá-lo a qualquer momento.',
        choose_alternative_address: 'Escolhe um endereço alternativo',
        the_acutal_amount_you_will_be_credited: 'A quantidade real que te será creditada depende no {x} preço na altura em que recebermos o teu pagamento.',
        only_l1_transactions: '<span class="text-cy">Apenas transações L1 são suportadas. Não uses transações internas e contratos inteligentes!</span> ',
      },
      zen: {
        zen: 'Deposita com ZEN',
        deposit_started: 'Depósito ZEN inicado,',
        open_the_zen_deposit_page: 'abre a página de depósito ZEN',
        processing_fee: 'A ZEN vai adicionar uma taxa de processamento de transação que depende no método de pagamento selecionado.<br> A quantia final de transação será visível no website deles.',
        each_transaction_is_reviewed: 'Cada transação é revista pela ZEN Pay e pode demorar <span class="text-cp">entre um minuto até algumas horas</span> para completar.',
      },
      the_minimum_deposit_amount_is: 'O valor de depósito mínimo é {amount}.',
      the_maximum_deposit_amount_is: 'O valor de depósito máximo é {amount}.',
    },
    withdraw: {
      only_binance_com_is_supported: '<span class="text-cy">Oferecemos pagamentos apenas para binance.com (binance.us não é suportado).</span>',
      bitcoin: 'Levantar BTC',
      litecoin: 'Levantar LTC',
      ethereum: 'Levantar ETH',
      unlimint: 'Levantar para um cartão VISA',
      tipalti: {
        tipalti: 'Levantar com Tipalti',
        tipalti_allows_you_to_withdraw: 'Tipalti permite que levantes os teus fundos para o teu banco e conta PayPal.',
        you_dont_have_a_tipalti_acount: 'Não tens uma conta Tipalti?',
        you_have_to_create_an_account: 'Para levantares os teus fundos através da Tipalti primeiro precisas de criar uma conta no website deles.<br> Podes fazê-lo clicando no butão abaixo.',
        create_tipalti_account: 'Criar conta Tipalti',
        check_your_email: 'Por favor verifica <span class="text-cp">a tua caixa de email</span> e clica no link de confirmação para completares o processo de criação da tua conta. Se não conseguires encontres a mensagem de email na tua caixa, por favor verifica o teu ficheiro de spam',
        payment_method: 'Método de pagamento',
        tipalti_panel: 'Painel Tipalti',
        tipalti_payouts_incur_a_fee: 'Pagamentos Tipalti incorrem numa taxa que pode chegar aos $26. A taxa depende no método de pagamento selecionado. Abaixo podes encontrar a tabela com a taxa de cada método de pagamento.',
        fee_per_payment: 'Taxa por pagamento',
        rejection_fee: 'Taxa de rejeição',
        echeck_local: 'eCheck (Local)',
        paypal_non_us: 'PayPal (não-residente US)',
        paypal_us: 'PayPal (residente US)',
        wire_transfer_non_us_non_usd: 'Transferência Bancária (não-residente US pago em não-USD)',
        wire_transfer_non_us_usd: 'Transferência Bancária (não-residente US pago em USD)',
        wire_transfer_us: 'Transferência Bancária (residente US)',
        up_to_21_usd: 'até $21.00',
        up_to_2_usd: 'até $2.00',
      },
      payoneer: 'Levantar com Payoneer',
      binance_pay: 'Levantar com Binance Pay',
      binancepay: 'Levantar com Binance Pay',
      p2p: 'Transferência P2P',
      payouts_are_performed_on_a_rolling_basis: 'Pagamentos são feitos numa base móvel até 5 minutos após serem pedidos.',
      your_payout_will_be_processed_at_the_current_rate: 'O teu pagamento será processado ao rate atual.',
      please_verify_the_wallet_address: 'Por favor verifica o endereço de carteira. Não podemos reembolsar um levantamento incorreto.',
      the_data_controller: 'O controlador de informação e parte contraente com a Unlimited em respeito aos pagamentos processados por eles na BitSkins Sp. z o.o. com escritório registrado em 40-246 Katowice, Porcelanowa str. 23, Poland, registrado no número: 0000810143 - mais detalhes podem ser encontrados na Política de Privacidade e nos ToS.',
      visa_withdrawals_are_processed_instantly: 'Levantamentos VISA são processados instantaneamente. Contudo, em alguns casos pode demorar vários dias antes do dinheiro aparecer na tua conta bancária.',
      card_info: 'Informação do cartão',
      ccv: 'CCV',
      add_new_deposit_needed: 'Adicionar novo (depósito necessário)',
      you_can_have_max_3_bank_cards: 'Podes ter um máximo de três cartões bancários assignados à tua conta.',
      your_cards_amount: '<span class="text-cp">Os teus</span> cartões ({x}/3)',
      the_minimum_withdraw_amount_is_x: 'O valor mínimo de levantamento é {x}',
      the_maximum_withdraw_amount_is_x: 'O valor máximo de levantamento é {x}',
      enter_amount: 'Digita a quantia',
      go_to_card_deposit: 'Ir para depósito por cartão',
      to_be_able_to_withdraw_your_funds_you_need_to_verify_your_card: 'Para poderes levantar fundos precisas de verificar o teu cartão primeiro. Podes fazê-lo depositando $1.',
      deposited_funds_are_non_withdrawable: 'Por favor tem em atenção que fundos depositados não podem ser levantados e podem ser apenas usados para compras.',
      we_do_not_support_mastercard_withdrawals: 'Não suportamos levantamentos para cartões MasterCard  e para cartões emitidos nos seguintes países: Bósnia e Herzegovina, Canada, Egipto, Japão, Cambójia, Coreia (a República da), KOSOVO, Macedónia do Norte, Estados Unidos da América, Argentina.',
      your_card_is_valid_until: 'O teu cartão é válido até 16.02.2023, 15:35 (UTC). Depois desta data terás de voltar a verificar o teu cartão depositando $5.',
      card_verification_required: '<span class="text-cp">Verficação de cartão</span> necessária',
      card: 'Cartão',
      add_new_card: '<span class="text-cp">Adicionar um novo</span> cartão',
      how_to_find_my_binance_id: 'Como encontrar o meu User ID (BUID) na Binance?',
      how_to_find_my_pay_id: 'Como encontrar o meu Pay ID na Binance?',
      how_to_find_my_email: 'Como encontrar o meu email na Binance?',
      binance_id: 'ID Binance',
      receiver_type: 'Tipo de receptor',
      i_do_not_have_a_binance_account: 'Não tenho uma conta Binance',
      i_have_a_binance_account: 'Tenho uma conta Binance',
      binance_account: 'Conta <span class="text-cp">Binance</span>',
      the_fee_is_already_included_in_the_current_x_rate: 'A taxa de {fee}% já está incluída na taxa {x} atual.',
    },
    wallet: {
      transfer: 'Transferência de fundos',
      refund: 'Reembolso de fundos',
      available_payment_methods: 'Métodos de pagamento disponíveis',
      bank_cards: 'Cartões bancários',
      kyc_required_for_this_payment_method: 'Não podes usar este método de pagamento porque não completaste o procedimento KYC. Podes começar o processo de verificação agora.',
      kyc_limit_exceeded: 'Não podes usar este método de pagamento porque excedeste o limite de transações para o teu nível de KYC. Podes agora começar o processo de verificação para remover as restrições.',
      no_limit: 'Sem limite',
      limits_info: 'Na Bitskins <strong>cada transação tem o seu próprio temporizador e limite que reiniciam um ano após a mesma</strong>. O máximo que podes depositar ou levantar é mostrado nos gráficos. Podes aumentar estes limites ou removê-los por completo através do procedimento KYC.',
      crypto_deposits: 'Depósitos em crypto',
      crypto_withdrawals: 'Levantamentos em crypto',
      standard_deposits: 'Depósitos padrão',
      standard_withdrawals: 'Levantamentos padrão',
      coupons_are_excluded_from_the_limit: '* cupões são excluídos do limite',
      x_type_does_not_incur_any_fees: '{x} {type} não incorre nenhumas taxas.',
      incur_fees_of: 'incorre em taxas de',
      plus: 'mais',
      the_minimum_type_amount_is: 'A quantia <span class="color-primary">mínima {type}</span> é',
      the_maximum_type_amount_is: 'A quantia <span class="color-primary">máxima {type}</span> é',
      due_to_unstable_crypto_network: 'Devido a network de crypto instável podes experienciar alguns delays.',
      binance_temporarily_disabled: 'Levantamentos de saldo estão desabilitados até Segunda feira (28.08.2023)',
    },
  },
  enum: {
    report_type: {
      balance: 'Saldo',
      sell: 'Vendido',
      buy: 'Comprado',
    },
    report_status: {
      empty: 'Vazio',
      pending: 'Pendente',
      done: 'Feito',
    },
    autobump_period: {
      hour_1: '1h',
      hour_3: '3h',
      hour_6: '6h',
      hour_12: '12h',
      hour_24: '24h',
      hour_48: '48h',
    },
    autobump_status: {
      not_enough_bumps: 'Sem bumps suficientes',
      finished: 'Finalizado',
      cancelled: 'Cancelado',
      pending: 'Pendente',
      active: 'Ativo',
    },
    inventory_status: {
      issue: 'Problema',
      not_available: 'Indisponíveis',
      deleted: 'Listagens removidas',
      withdrawn: 'Levantamentos',
      delisted: 'Listagens removidas',
      ready: 'Pronto',
      listed: 'Listagens',
      listed_private: 'Listagens privadas',
      sold: 'Vendido',
      withdraw_queue: 'Fila de Levantamentos',
      withdraw_pending: 'Levantamento Pendente',
      instant_sell: 'Venda Instantânea',
    },
    service: {
      market: {
        buy: 'Comprar',
        sell: 'Vender',
        fee: 'Taxa de venda',
        buy_order: 'Ordem de compra',
        bargain: 'Barganha',
        instant_sell: 'Venda Instantânea',
        bump: 'Bump',
        bump_package: 'Pacote de Bumps',
      },
      deposit: {
        bitcoin: 'Depositar BTC',
        litecoin: 'Depositar LTC',
        ethereum: 'Depositar ETH',
        unlimint: 'Depositar com cartão bancário',
        zen: 'Depositar com ZEN',
        gift_code: 'Código de Presente',
        binancepay: 'Depositar com Binance Pay',
      },
      withdraw: {
        bitcoin: 'Levantar BTC',
        litecoin: 'Levantar LTC',
        ethereum: 'Levantar ETH',
        unlimint: 'Levantar para um cartão VISA',
        tipalti: 'Levantar com Tipalti',
        payoneer: 'Levantar com Payoneer',
        binancepay: 'Levantar com Binance Pay',
        p2p: 'Transferência P2P',
      },
      wallet: {
        transfer: 'Transferência de fundos',
        refund: 'Reembolso de fundos',
      },
      marketing: {
        coupon: 'Cupão',
        referral: 'Referência',
        affiliate: 'Afiliado',
      },
    },
  },
  meta: {
    default_title: 'BitSkins 2024',
    default_description: 'A BitSkins oferece uma plataforma simples para comprares e venderes os teus itens de CS2, DOA2, TF2, RUST. Explora a vasta seleção de espingardas, facas, luvas e mais. Junta-te agora para trocares com facilidade!',
    home_title: 'BitSkins.com - Compra e Vende Skins de CS2. Trocas Rápidas, Facéis e Seguras',
    home_description: 'A BitSkins oferece uma plataforma desatada para comprares e venderes os teus itens de CS2, DOTA2, TF2, RUST. Explora a vasta seleção de espingardas, facas, luvas e mais. Junta-te agora com facilidade!',
    support_title: 'Suporte BitSkins: Recebe Assistência para as tuas necessidades de trocas CS2',
    support_description: 'Precisas de ajuda com trocas de CS2? Visita a página de suporte da BitSkins para uma assistência rápida. A nossa equipa para responder às tuas questões, resolver problemas e oferecer orientação.',
    item_title: '{item} - {game} Skins | Encontra e troca os teus itens {game} desejados',
    item_description_csgo: 'Descobre e troca as tuas skins de CS2 desejadas na BitSkins. Explore a vast selection of rifles, knives, gloves, and more. Compra, vende ou levanta instantaneamente. Começa a navegar hoje!',
    item_description_cs2: 'Descobre e troca as tuas skins de CS2 desejadas na BitSkins. Explore a vast selection of rifles, knives, gloves, and more. Compra, vende ou levanta instantaneamente. Começa a navegar hoje!',
    item_description_dota2: 'Descobre e troca as tuas skins de DOTA2 desejadas na BitSkins. Explora a nossa vasta coleção de wards, músicas, bundles e mais. Compra, vende ou levanta instantaneamente. Começa a navegar agora!',
    item_description_tf2: 'Descobre e troca os teus itens de TF2 desejados. Explora a nossa vasta coleção de cosméticos, provocações, caixas e mais. Compra, vende e levanta instantaneamente. Começa a navegar agora!',
    item_description_rust: 'Descobre e troca os teus itens de RUST desejados. Explora a nossa vasta coleção de roupas, armas, recursos e mais. Compra, vende e levanta instantaneamente. Começa a navegar agora!',
    market_title: 'Mercado BitSkins: Explora e Troca Itens de {game} com Facilidade',
    market_description_csgo: 'Entra no Mercado BitSkins e explora uma variedade de itens de CS2 sem esforços. Descobre os melhores negócios em skins, chaves, cápsulas e mais. Compra, vende e levanta instantaneamente.',
    market_description_cs2: 'Entra no Mercado BitSkins e explora uma variedade de itens de CS2 sem esforços. Descobre os melhores negócios em skins, chaves, cápsulas e mais. Compra, vende e levanta instantaneamente.',
    market_description_dota2: 'Entra no Mercado BitSkins e explora uma variedade de itens de DOTA2 sem esforços. Descobre os melhores negócios em wards, musicas, bundles e mais. Compra, vende e levanta instantaneamente.',
    market_description_tf2: 'Entra no Mercado BitSkins e explora uma variedade de itens de TF2 sem esforços. Descobre os melhores negócios em cosméticos, provocações, caixas e mais. Compra, vende e levanta instantaneamente.',
    market_description_rust: 'Entra no Mercado BitSkins e explora uma variedade de itens de RUST sem esforços. Descobre os melhores negócios em roupas, armas, recursos e mais. Compra, vende e levanta instantaneamente.',
    market_item_title: 'Mercado BitSkins: {skin} : {game} Mercado',
    store_title: 'Loja de Utilizador BitSkins: {alias} - {game} Mostruário de Itens',
    store_description: 'Loja de Utilizador BitSkins para mostrares e venderes os teus itens. Define os teus preços, comunica com compradores, e estabelece a tua presença no comunidade de trocas.',
    login_title: 'Login BitSkins: Acesso Seguro à tua conta de trocas de CS2',
    login_description: 'Entra na tua conta BitSkins com segurança. Tem Acesso ao teu inventário de CS2, gere os teus itens, faz transações e aproveita uma experiência de trocas descomplicada.',
    steam_login_title: 'Entra com a Steam',
    profile_title: 'As definições da tua conta',
    wallet_title: 'Os teus fundos BitSkins',
    affiliate_title: 'Painel de Afiliados BitSkins: Recebe recompensas por referências',
    affiliate_description: 'Junta-te ao pograma de Afiliados da BitSkins ao referenciares entusiastas de skins. Beneficia de um lucrativo pograma de afiliados, segue as tuas referências e maximiza os teus ganhos',
    statistics_title: 'Estatísticas de venda BitSkins: Descobre Tendências de Mercado e Perceções ',
    statistics_description: 'Explora estatísticas compreensivas na BitSkins para ganhares perceções valiosas nas tendências das trocas de CS2. Analisa a informação do mercado, popularidade de um item e mais para otimizares as tuas estratégias de trocas.',
    sales_fees_title: 'Taxas de vendas BitSkins: Preço transparente para as tuas vendas CS2',
    sales_fees_description: 'Tem um entendimento claro da estrutura de taxas de venda da BitSkins. As nossas taxas transparentes asseguram justiça e simplicidade para as tuas vendas de CS2. Sabe mais.',
    checkout_title: 'Carrinho BitSkins: Checkout conveniente para itens de CS2',
    checkout_description: 'Simplifica a tua experiência de trocas de CS2 com o carrinho BitSkins. Gere com facilidade os teus itens, revê o teu pedido, e procede com um checkout seguro. Disfruta de um processo de troca simples hoje!',
    steam_inventory_title: 'O meu inventário Steam de {game}',
    bs_inventory_title: 'O meu inventário BitSkins de {game}',
    selling_inventory_title: 'Os meus itens anunciados de {game}',
    buy_order_create_title: 'Criando ordens de compra para {game}',
    buy_order_active_title: 'Ordens de compra ativas para {game}',
    buy_order_title: 'Ordens de compra para {game}',
    trades_active_title: 'Trocas ativas',
    trades_history_title: 'Histórico de trocas',
    transactions_title: 'Transações',
    favorites_title: 'Itens favoritos',
    kyc_title: 'Formulário de aplicação Know Your Costumer (KYC)',
    tos_title: 'Termos de Uso da BitSkins: Diretrizes para Trocas Seguras e Confiáveis',
    tos_description: 'Revê os nossos Termos de Uso para trocas seguras e de confiança. Familiariza-te com as nossas políticas e obrigações. Troca com segurança na BitSkins.',
    privacy_policy_title: 'Política de Privacidade da BitSkins: Salvaguardando a tua informação pessoal',
    privacy_policy_description: 'Lê a Política de Privacidade da BitSkins para saberes como protegemos a tua informação pessoal. Confiança e transparência são o núcleo da nossa comunidade. ',
    cookie_policy_title: 'Política de Cookies da BitSkins: Importamo-nos com a tua privacidade',
    cookie_policy_description: 'Na BitSkins, nós valorizamos a tua privacidade. Lê a nossa Política de Cookies para perceberes como usamos os cookies e tecnologias semelhantes. A tua confiança e a segurança dos teus dados são as nossas principais prioridades.',
    docs_v1_title: 'BitSkins API V1: Versão de API Legado',
    docs_v1_description: 'Integra o BitSkins API V1 para trocas facilitadas. Tem acesso à documentação para otimizares as tuas capacidades de troca. Atualiza para a última versão para novas características.',
    docs_v2_title: 'BitSkins API V2: A mais recente Versão API',
    docs_v2_description: 'Desbloqueia novas características com o BitSkins API V2. Melhora as tuas estratégias de troca e eficiência. Explora a nossa documentação compreensiva agora!',
    docs_migration_title: 'Migração de API BitSkins: Muda facilmente para o novo API',
    docs_migration_description: 'Migra facilmente para o novo API da BitSkins com o nosso guião compreensivo. Explora novas características e processos de integração para uma experiência de trocas melhorada.',
  },
  alt: {
    envelope: 'Envelope',
    app_store: 'Apple Store',
    google_store: 'Google Store',
  },
  time: {
    seconds: 'segundos',
  },
  calendar: {
    week: 'Semana',
    month: 'Mês',
    lifetime: 'Para sempre',
  },
  docs: {
    docs: 'Documentos',
    api: 'API',
    api_v1: 'API V1 (Gateway)',
    api_v2: 'API V2',
    api_migration_guide: 'Guia de migração de API',
    request_parameters: 'Pedir parâmetros',
    sample_request: 'Pedido de amostra',
    sample_response: 'Resposta de amostra',
    request_schema: 'Pedir schema',
    enums: 'ENUMS',
  },
  wallet: {
    coupon_redeemed: 'Redimiste um cupão de {amount}',
    balance_changed: 'Saldo foi atualizado',
    transfer_p2p_confirm: 'Confirma a transferência de fundos para p2p.bitskins.com',
    transfer_p2p_confirm_needed: 'Precisas de confirmar a transferência',
    transfer_p2p_success: 'Os teus fundos foram transferidos para p2p.bitskins.com',
    transfer_funds: 'Transfere os fundos',
    deposit_started: 'Depósito iniciado',
    card_removed: 'Cartão removido',
    confirm_card_remove: 'Tens a certeza de que queres remover este cartão?',
    delete_card: 'Eliminar cartão',
    deposit: 'depositar',
    withdraw: 'levantar',
    security_code: 'Código de segurança',
    security_code_ccv: 'Código de segurança',
    card_number: 'Número do cartão',
    full_name: 'Nome completo',
    month_expired: 'Mês de expiração (MM/YYYY)',
    addr_line_1: 'Morada de Faturação (linha 1)',
    addr_line_2: 'Morada de Faturação (linha 2)',
    zip: 'ZIP ou Código Postal',
    city: 'Cidade',
    country: 'País',
    withdraw_only_to_visa: 'Só podes levantar fundos para um cartão Visa',
    card_country_is_restricted: 'Infelizmente, não fornecemos levantamentos para cartões de {country}',
  },
  twofa: {
    required: 'Autenticação de 2-Fatores exigida',
    required_for_this_payment_method: 'Não podes usar este método de pagamento porque não configuraste a autenticação de 2-Fatores.',
    you_can_start_now: 'Podes começar o processo de configuração agora.',
    setup: 'Configurar 2FA',
    why_we_require: 'Clicar para ler - Porque exigimos 2FA para levantamentos?',
  },
  password_strong: {
    minimum: 'A palavra-pass precisa de ter pelo menos {value} caracteres',
    maximum: 'A palavra-pass precisa de ter no máximo {value} caracteres',
    lowercase: 'A palavra-pass precisa de ter pelo menos 1 letra minúscula',
    uppercase: 'A palavra-pass precisa de ter pelo menos 1 letra maiúscula',
    numeric: 'A palavra-pass precisa de ter pelo menos 1 número',
    special: 'A palavra-pass precisa de ter pelo menos 1 digito especial',
  },
  help_center: {
    help_center: 'Centro de ajuda',
    hello: 'Olá, como podemos ajudar?',
    create_ticket: 'Criar ticket',
    contact_us: 'Contacta-nos',
    guide: 'Guia',
    top_articles: 'Artigos de topo',
    didnt_find: 'Não encontraste o que precisavas?',
    article: 'Artigos',
    general: 'Geral',
    fees: 'Taxas',
    buying_selling: 'Comprar e Vender',
    deposit_withdrawal: 'Depósitos e Levantamentos',
    refunds: 'reembolsos',
    user_account: 'Conta do Utilizador',
    affiliate: 'Afiliado',
    partnership: 'Parceria',
    scam: 'Scam suspeito',
    was_helpful: 'Este artigo foi útil?',
    found_helpful: '{yes} de {max} acham-no útil',
    faq: 'Questões <span class="color-primary">Frequentemente</span> perguntadas',
  },
};
